import { rbacController } from '../auth/rbacController.js';
import { authService } from '../auth/authService.js';
import { appState } from '../core/stateManager.js';
import { naverBlogService } from '../services/naverBlogService.js';

const safeMarkedParse = (text) => {
    if (typeof marked !== 'undefined') {
        if (typeof marked.parse === 'function') {
            return marked.parse(text || "");
        } else if (typeof marked === 'function') {
            return marked(text || "");
        }
    }
    return (text || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");
};

let sourcingPagination = {
    currentPage: 1,
    pageSize: 15,
    totalRecords: 0
};

window.adminFormChanged = false;

const ADMIN_STATE_KEY = 'auraDoc_adminState';
const defaultState = {
    v: 9.58,
    aiProvider: 'gemini',
    routingMode: 'fixed',
    activeModelKey: 'gemini:gemini-1.5-flash',
    openrouterApiKey: '',
    freellmUrl: 'https://freellm.gofunwith.com/v1',
    freellmApiKey: '',
    geminiApiKey: '', // For direct Gemini calls
    ollamaUrl: 'http://localhost:11434/api/generate',
    ollamaModel: 'gemma:4b',
    aiSettingsSchemaVersion: 1,
    workModes: [
        { id: 1, name: '제안서 작성', status: '활성' },
        { id: 2, name: '빠른 비즈니스 문서', status: '활성' }
    ],
    documentTypes: [
        { id: 1, name: '회의록', prompt: '입력된 텍스트에서 일시, 장소, 참석자, 주요 안건, 결정 사항, Action Item을 구조화하여 표 형태로 작성할 것.', template: '기본 회의록 양식' },
        { id: 2, name: '이메일', prompt: '수신자에게 예의를 갖추되 목적이 명확히 드러나도록 [제목]과 [본문]을 나누어 작성하라.', template: '' },
        { id: 3, name: '사업수행계획서', prompt: '개요, 일정, 투입 인력, 예산을 논리적인 목차로 세분화하여 개조식으로 작성하라.', template: '표준 사업계획서 양식' },
        { id: 4, name: '보고서', prompt: '현황, 문제점, 개선방안, 기대효과 순으로 구조화하여 핵심 내용을 명확하게 전달하라.', template: 'A4 1장 보고서 양식' },
        { id: 5, name: '기술소개서', prompt: '핵심 기술의 차별점, 아키텍처, 기대 효과를 전문가 수준에서 상세히 기술하라.', template: '' },
        { id: 6, name: '제안요청서 요약', prompt: 'RFP의 핵심 요구사항, 평가 항목, 제약 조건을 요약하여 관리용 대시보드 형태로 구성하라.', template: '' },
        { id: 7, name: '인터뷰 가이드', prompt: '대상자의 직무와 프로젝트 목표에 맞는 질문 리스트를 구조화하여 생성하라.', template: '' },
        { id: 8, name: '블로그', prompt: '독자의 흥미를 유발할 수 있는 제목과 소제목을 사용하고, 친근하고 읽기 쉬운 문체로 작성하라. SEO를 고려하라.', template: '' }
    ],
    tones: [
        { id: 1, name: '전문적인', prompt: '격식을 갖춘 비즈니스 용어를 사용하고, 감정 표현을 배제할 것.' },
        { id: 2, name: '설득력 있는', prompt: '핵심 주장을 강조하고, 기대 효과와 이점을 부각시키는 톤으로 작성할 것.' },
        { id: 3, name: '친근한', prompt: '부드럽고 이해하기 쉬운 용어를 사용하며, 독자와 소통하는 듯한 톤으로 작성할 것.' },
        { id: 4, name: '객관적인', prompt: '사실과 데이터에 근거하여 건조하고 중립적인 문체로 서술할 것.' }
    ],
    audiences: [
        { id: 1, name: '일반' },
        { id: 2, name: '전문가' },
        { id: 3, name: '경영진' },
        { id: 4, name: '대중' }
    ],
    aiModels: [
        { key: 'gemini:gemini-1.5-flash', name: 'Gemini 1.5 Flash', provider: 'gemini', endpoint: 'default', modelCode: 'gemini-1.5-flash', description: '빠른 응답 속도의 경량 작업용', source: 'builtin', enabled: true },
        { key: 'gemini:gemini-1.5-pro', name: 'Gemini 1.5 Pro', provider: 'gemini', endpoint: 'default', modelCode: 'gemini-1.5-pro', description: '고성능 업무 및 복잡한 추론 최적화', source: 'builtin', enabled: true },
        { key: 'local:gemma4:26b', name: 'Local Gemma 4 26B', provider: 'local', endpoint: 'http://localhost:11434/api/generate', modelCode: 'gemma4:26b', description: '강력한 보안을 제공하는 로컬 전용 Gemma 4 모델', source: 'builtin', enabled: true },
        { key: 'local:gemma2:9b', name: 'Local Gemma 2 9B', provider: 'local', endpoint: 'http://localhost:11434/api/generate', modelCode: 'gemma2:9b', description: '폐쇄망 보안 환경용 로컬 모델', source: 'builtin', enabled: true },
        { key: 'openrouter:tencent/hy3-preview:free', name: 'Tencent: Hy3 preview (free)', provider: 'openrouter', endpoint: 'https://openrouter.ai/api/v1', modelCode: 'tencent/hy3-preview:free', description: 'OpenRouter 제공 무료 모델', source: 'builtin', enabled: true },
        { key: 'openrouter:nvidia/nemotron-3-super:free', name: 'NVIDIA: Nemotron 3 Super (free)', provider: 'openrouter', endpoint: 'https://openrouter.ai/api/v1', modelCode: 'nvidia/nemotron-3-super:free', description: 'OpenRouter 제공 무료 모델', source: 'builtin', enabled: true },
        { key: 'openrouter:anthropic/claude-3-sonnet', name: 'Claude 3.5 Sonnet (OR)', provider: 'openrouter', endpoint: 'https://openrouter.ai/api/v1', modelCode: 'anthropic/claude-3.5-sonnet', description: '최고 수준의 비즈니스 글쓰기 및 분석', source: 'builtin', enabled: true },
        { key: 'openrouter:openai/gpt-4o', name: 'GPT-4o (OR)', provider: 'openrouter', endpoint: 'https://openrouter.ai/api/v1', modelCode: 'openai/gpt-4o', description: '범용 최상위 모델 및 오피스 자동화', source: 'builtin', enabled: true },
        { key: 'openrouter:google/gemini-pro-1.5', name: 'Gemini 1.5 Pro (OR)', provider: 'openrouter', endpoint: 'https://openrouter.ai/api/v1', modelCode: 'google/gemini-pro-1.5', description: '멀티모달 분석 및 긴 문맥 처리', source: 'builtin', enabled: true },
        // FreeLLM API Models
        { key: 'freellmapi:minimax-m2.5', name: 'MiniMax M2.5 (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'minimax-m2.5', description: 'openrouter, Intel #1, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-3.1-pro-preview', name: 'Gemini 3.1 Pro Preview', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-3.1-pro-preview', description: 'google, Intel #1, Speed #8, 5 rpm, 20 rpd, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:qwen3-coder', name: 'Qwen3 Coder (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'qwen3-coder', description: 'openrouter, Intel #2, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:qwen3-coder-480b', name: 'Qwen3-Coder 480B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'qwen3-coder-480b', description: 'ollama, Intel #2, Speed #9, ~5-10M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:qwen3-coder-480b-nv', name: 'Qwen3-Coder 480B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'qwen3-coder-480b-nv', description: 'nvidia, Intel #2, Speed #9, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:qwen3-next-80b', name: 'Qwen3-Next 80B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'qwen3-next-80b', description: 'openrouter, Intel #3, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:mistral-large-3-675b', name: 'Mistral Large 3 675B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'mistral-large-3-675b', description: 'ollama, Intel #3, Speed #9, ~5-10M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:deepseek-v4-pro', name: 'DeepSeek V4 Pro (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'deepseek-v4-pro', description: 'nvidia, Intel #3, Speed #9, 40 rpm, ~2M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:mistral-large-3-675b-nv', name: 'Mistral Large 3 675B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'mistral-large-3-675b-nv', description: 'nvidia, Intel #3, Speed #9, 40 rpm, ~2M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:minimax-m2.7', name: 'MiniMax M2.7 (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'minimax-m2.7', description: 'nvidia, Intel #3, Speed #9, 40 rpm, ~2M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:kimi-k2.6', name: 'Kimi K2.6 (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'kimi-k2.6', description: 'nvidia, Intel #3, Speed #9, 40 rpm, ~2M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-3.5-flash', name: 'Gemini 3.5 Flash', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-3.5-flash', description: 'google, Intel #3, Speed #5, 10 rpm, 20 rpd, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:qwen3-coder-next', name: 'Qwen3-Coder Next (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'qwen3-coder-next', description: 'ollama, Intel #3, Speed #9, ~10-20M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:deepseek-v3.2', name: 'DeepSeek V3.2 (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'deepseek-v3.2', description: 'ollama, Intel #4, Speed #9, ~5-10M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:cogito-2.1-671b', name: 'Cogito 2.1 671B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'cogito-2.1-671b', description: 'ollama, Intel #4, Speed #9, ~5-10M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:deepseek-v4-flash', name: 'DeepSeek V4 Flash (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'deepseek-v4-flash', description: 'nvidia, Intel #4, Speed #9, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:kimi-k2-thinking', name: 'Kimi K2 Thinking (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'kimi-k2-thinking', description: 'ollama, Intel #5, Speed #9, ~5-10M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:trinity-large-thinking', name: 'Trinity Large Thinking (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'trinity-large-thinking', description: 'openrouter, Intel #5, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:owl-alpha', name: 'Owl Alpha (OR-house)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'owl-alpha', description: 'openrouter, Intel #5, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:glm-5.1', name: 'GLM-5.1 (NV, slow cold-start)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'glm-5.1', description: 'nvidia, Intel #5, Speed #9, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-120b', name: 'GPT-OSS 120B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-120b', description: 'openrouter, Intel #6, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-120b-groq', name: 'GPT-OSS 120B (Groq)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-120b-groq', description: 'groq, Intel #6, Speed #2, 30 rpm, 1000 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:glm-4.7', name: 'GLM-4.7 (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'glm-4.7', description: 'ollama, Intel #6, Speed #9, ~5-10M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-120b-ollama', name: 'GPT-OSS 120B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-120b-ollama', description: 'ollama, Intel #6, Speed #9, ~10-20M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:compound', name: 'Compound (Groq)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'compound', description: 'groq, Intel #6, Speed #2, 30 rpm, 250 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:cobuddy', name: 'CoBuddy (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'cobuddy', description: 'openrouter, Intel #6, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:glm-4.5-air', name: 'GLM-4.5 Air (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'glm-4.5-air', description: 'openrouter, Intel #8, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:devstral-2-123b', name: 'Devstral 2 123B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'devstral-2-123b', description: 'ollama, Intel #8, Speed #10, ~10-20M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-3-flash-preview', name: 'Gemini 3 Flash Preview', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-3-flash-preview', description: 'google, Intel #11, Speed #5, 10 rpm, 20 rpd, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-4-maverick', name: 'Llama 4 Maverick (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-4-maverick', description: 'nvidia, Intel #11, Speed #6, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-4-scout', name: 'Llama 4 Scout', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-4-scout', description: 'groq, Intel #12, Speed #2, 30 rpm, 1000 rpd, ~30M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:poolside-laguna-m.1', name: 'Poolside Laguna M.1 (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'poolside-laguna-m.1', description: 'openrouter, Intel #13, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-2.5-pro', name: 'Gemini 2.5 Pro', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-2.5-pro', description: 'google, Intel #14, Speed #8, 5 rpm, 50 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-3.3-70b', name: 'Llama 3.3 70B', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-3.3-70b', description: 'groq, Intel #17, Speed #2, 30 rpm, 1000 rpd, ~15M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-3.1-70b-nv', name: 'Llama 3.1 70B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-3.1-70b-nv', description: 'nvidia, Intel #17, Speed #6, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-3.3-70b-free', name: 'Llama 3.3 70B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-3.3-70b-free', description: 'openrouter, Intel #17, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-3.3-70b-nv-alt', name: 'Llama 3.3 70B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-3.3-70b-nv-alt', description: 'nvidia, Intel #17, Speed #6, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-3.1-8b-instant', name: 'Llama 3.1 8B Instant (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-3.1-8b-instant', description: 'groq, Intel #8, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:hermes-3-405b', name: 'Hermes 3 405B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'hermes-3-405b', description: 'openrouter, Intel #17, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-20b', name: 'GPT-OSS 20B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-20b', description: 'openrouter, Intel #18, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-20b-groq', name: 'GPT-OSS 20B (Groq)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-20b-groq', description: 'groq, Intel #18, Speed #2, 30 rpm, 1000 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-3.1-flash-lite-preview', name: 'Gemini 3.1 Flash-Lite Preview', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-3.1-flash-lite-preview', description: 'google, Intel #18, Speed #3, 15 rpm, 20 rpd, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-20b-ollama', name: 'GPT-OSS 20B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-20b-ollama', description: 'ollama, Intel #18, Speed #10, ~20-30M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:compound-mini', name: 'Compound Mini (Groq)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'compound-mini', description: 'groq, Intel #18, Speed #2, 30 rpm, 250 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gpt-oss-safeguard-20b', name: 'GPT-OSS Safeguard 20B (Groq)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gpt-oss-safeguard-20b', description: 'groq, Intel #18, Speed #2, 30 rpm, 1000 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:qwen3-32b', name: 'Qwen3 32B (Groq)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'qwen3-32b', description: 'groq, Intel #19, Speed #2, 60 rpm, 1000 rpd, ~15M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemma-4-31b', name: 'Gemma 4 31B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemma-4-31b', description: 'nvidia, Intel #19, Speed #9, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemma-4-31b-free', name: 'Gemma 4 31B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemma-4-31b-free', description: 'openrouter, Intel #19, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-2.5-flash', name: 'Gemini 2.5 Flash', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-2.5-flash', description: 'google, Intel #20, Speed #5, 10 rpm, 20 rpd, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:nemotron-3-super-120b', name: 'Nemotron 3 Super 120B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'nemotron-3-super-120b', description: 'openrouter, Intel #22, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemma-4-26b-a4b', name: 'Gemma 4 26B-A4B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemma-4-26b-a4b', description: 'openrouter, Intel #22, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemma-4-31b-ollama', name: 'Gemma 4 31B (Ollama)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemma-4-31b-ollama', description: 'ollama, Intel #22, Speed #10, ~20-30M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:nemotron-3-super-120b-nv', name: 'Nemotron 3 Super 120B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'nemotron-3-super-120b-nv', description: 'nvidia, Intel #22, Speed #9, 40 rpm, ~2M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:nemotron-3-nano-30b-nv', name: 'Nemotron 3 Nano 30B (NV)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'nemotron-3-nano-30b-nv', description: 'nvidia, Intel #22, Speed #9, 40 rpm, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:nemotron-3-nano-30b', name: 'Nemotron 3 Nano 30B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'nemotron-3-nano-30b', description: 'openrouter, Intel #23, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:nemotron-3-nano-30b-reasoning', name: 'Nemotron 3 Nano 30B Reasoning (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'nemotron-3-nano-30b-reasoning', description: 'openrouter, Intel #23, Speed #9, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:gemini-2.5-flash-lite', name: 'Gemini 2.5 Flash-Lite', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'gemini-2.5-flash-lite', description: 'google, Intel #26, Speed #3, 15 rpm, 20 rpd, ~3M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:poolside-laguna-xs.2', name: 'Poolside Laguna XS.2 (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'poolside-laguna-xs.2', description: 'openrouter, Intel #26, Speed #10, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:llama-3.1-8b-instant', name: 'Llama 3.1 8B Instant', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'llama-3.1-8b-instant', description: 'groq, Intel #28, Speed #2, 30 rpm, 14400 rpd, ~15M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:nemotron-nano-9b-v2', name: 'Nemotron Nano 9B v2 (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'nemotron-nano-9b-v2', description: 'openrouter, Intel #28, Speed #10, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:liquid-lfm-2.5-1.2b', name: 'Liquid LFM 2.5 1.2B (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'liquid-lfm-2.5-1.2b', description: 'openrouter, Intel #30, Speed #10, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true },
        { key: 'freellmapi:liquid-lfm-2.5-1.2b-thinking', name: 'Liquid LFM 2.5 1.2B Thinking (free)', provider: 'freellmapi', endpoint: 'https://freellm.gofunwith.com/v1', modelCode: 'liquid-lfm-2.5-1.2b-thinking', description: 'openrouter, Intel #30, Speed #10, 20 rpm, 200 rpd, ~6M tok/mo', source: 'builtin', enabled: true }
    ],
    templates: [
        { id: 1, name: '표준 제안서 (그린)', type: '제안서', size: '1411x794', css: ":root{--brand-green:#86BC25;--dark-green:#046A38;--light-green1:#E8F6CF;--light-green2:#D1ECA0;--gray:#53565A;--black:#000;--white:#FFF}*{box-sizing:border-box;margin:0;padding:0}.slide{font-family:'NanumBarunGothic Light','Malgun Gothic',sans-serif;width:100%;height:100%;background:var(--white);padding:40px 50px;overflow:hidden;display:flex;flex-direction:column;flex-shrink:0}.section-title{font-size:26.7px;color:var(--black);margin-bottom:10px;flex-shrink:0}.divider{width:866px;height:4px;background-color:var(--brand-green);margin-bottom:20px;flex-shrink:0}.sub-section-title{font-size:37.3px;color:var(--black);font-weight:bold;margin-bottom:20px;flex-shrink:0}.governing-message{font-size:24px;color:var(--gray);font-weight:bold;line-height:1.4;margin-bottom:30px;overflow:hidden;flex-shrink:0}.body-container{display:flex;gap:25px;flex:1;min-height:0}.col-half{flex:1;display:flex;flex-direction:column;gap:15px;min-width:0;min-height:0}.box{flex:1;border:1px solid var(--brand-green);border-radius:6px;padding:20px;background:var(--light-green1);overflow:hidden;display:flex;flex-direction:column}.box-title{font-size:18.7px;font-weight:bold;margin-bottom:15px;color:var(--dark-green);border-bottom:1px solid var(--brand-green);padding-bottom:8px;flex-shrink:0}ul.bullet-list{list-style-type:square;margin-left:20px;font-size:16px;line-height:1.5;color:var(--black);overflow-y:auto}ul.bullet-list li{margin-bottom:8px}.ghosting-box{flex:1;background:var(--dark-green);color:var(--white);border-radius:6px;padding:20px;overflow:hidden;display:flex;flex-direction:column}.ghosting-box .box-title{color:var(--brand-green);border-bottom-color:var(--brand-green);flex-shrink:0}.ghosting-box ul{list-style:none;margin-left:0;color:var(--white);overflow-y:auto}.ghosting-box li::before{content:'⚠️ '} .footer{position:absolute;bottom:20px;left:50px;right:50px;display:flex;justify-content:space-between;font-size:10.7px;color:var(--gray)}", html: '<div class="slide">\n  <div class="title">슬라이드 제목</div>\n  <div class="content">여기에 내용을 입력하세요.</div>\n</div>' }
    ],
    permissions: [
        { id: 1, name: '문성진 (나)', email: 'moon.sungjin@vivaura.com', role: 'ADMIN', status: '활성' }
    ],
    prompts: {
        PROMPT_PROPOSAL_ANALYSIS: `너는 글로벌 탑티어 컨설팅 펌의 Senior Proposal Lead 이다.
[분석 목표] 1.전략적 핏 2.수익성 3.실행력 4.딜 브레이커
맨 첫 줄에 반드시 "[프로젝트명]: (사업명)" 기재.
---
### ✉️ [Part 1] 경영진 보고용 이메일 요약
---
### 🔍 [Part 2] 상세 분석 보고서
1. 사업 본질 및 범위
2. 제약 사항/리스크 분석
3. 딜 브레이커 질의
4. 제안서 작성 유의사항

※ 유의사항은 RFP에서 반드시 준수해야 하는 행정적/기술적 제약조건을 불렛포인트로 상세히 나열하라.`,
        PROMPT_PROPOSAL_TOC: `입력된 RFP 분석 결과와 고객의 니즈를 바탕으로, 경쟁사를 압도하는 제안 전략과 전략적 목차(TOC)를 수립하라.

[출력 구조 지침]

### Phase 1. 고객 문제 재정의
- 단순한 현상 나열이 아닌, 고객이 직면한 **근본적 문제와 숨겨진 니즈**를 날카롭게 재정의하라.
- 불렛포인트 3~4개로 구성하며, 핵심 키워드는 **굵게** 표시하라.

### Phase 2. 제안 및 경쟁 전략
1. **승리 전략 (Win Themes)**: 이 사업을 따내기 위한 핵심 전략 3가지를 명확히 제시하라.
2. **차별화 요소 (Differentiation)**: 경쟁사 대비 당사만이 가진 독보적인 강점(실적, 인력, 기술 등)을 기술하라.

### Phase 3. 전략적 목차 (TOC)
- 반드시 아래 마크다운 표 형식을 엄격히 준수하여 출력하라.
- 이 데이터는 시스템에 의해 자동 파싱되므로 헤더 순서를 절대 바꾸지 마시오.

| 레벨 | 목차명 | 분량(P) | 담당자 | 작성상태 | 세부 작성 내용 및 기준 |
| :--- | :--- | :---: | :---: | :---: | :--- |
| I | ... | ... | PM | 대기 | ... |

[TOC 작성 필수 규칙]
- **담당자(Owner)**: 절대 "홍길동" 같은 실제 인명을 쓰지 마시오. "PM", "PL", "Senior", "Expert", "Support" 등 역할명만 사용하시오.
- **작성상태**: "대기" 또는 "0%"로 고정하시오. (절대 "작성중", "완료" 등을 임의로 넣지 말 것)
- **레벨**: I, II, III 등 대목차와 1.1, 1.2 등 소목차 구분.

### Phase 4. 딜 브레이커 방어
- 고객사나 경쟁사로부터 예상되는 공격 포인트(약점)와 이에 대한 **논리적 방어전략(Defense)**을 제시하라.

### Phase 5. 내부 Kick-off 요약
- 일시/장소, 핵심 목표, 주요 Action Item, PM 전달사항을 포함하라.

---
[중요] 위 5개 Phase 형식을 반드시 지키고, 인사말이나 부연 설명 없이 마크다운으로만 응답하라.
`,
        PROMPT_PROPOSAL_SLIDE: `너는 글로벌 탑티어 컨설팅 펌의 비주얼 커뮤니케이션 전문가이자 전문 프레젠테이션 디자이너다.
[입력]: 제안 전략 요약 및 선정된 목차 데이터
[출력]: HTML/CSS 기반의 고품격 제안서 슬라이드

[작성 지침]
1. **마스터 골격 준수**: 각 슬라이드는 반드시 아래 구조를 기본으로 하라.
   <div class="slide" style="width:1411px; height:794px; flex-shrink: 0; position: relative; overflow: hidden; background: var(--white);">
     <div class="section-title">{{대목차}}</div>
     <div class="divider"></div>
     <div class="sub-section-title">{{소목차명}}</div>
     <div class="governing-message">슬라이드를 관통하는 핵심 메시지 (So What?)</div>
     <div class="body-container">
       <!-- 여기에 핵심 내용 배치 -->
     </div>
     <div class="footer"><span>Deloitte Consulting LLC</span><span>{{PageNo}}</span></div>
   </div>

2. **일관성 및 전문성**:
   - 거버닝 메시지는 2줄 이내로 작성하며, "~함/임" 체로 종결할 것.
   - 텍스트는 개조식으로 요약하여 가독성을 극대화하라.
   - 모든 슬라이드에서 헤더, 디바이더, 푸터의 위치와 스타일을 동일하게 유지하라.
3. **분량**: 요청된 목차별 페이지 수만큼 <div class="slide"> 블록을 연속해서 출력하라.
4. **시각화**: 이모지, 박스 모델(Border, Background), 불렛 포인트를 적절히 사용하여 텍스트 중심의 지루함을 탈피하라.
5. **제약사항**: 
   - \`\`\`html 단일 코드 블록으로만 응답할 것.
   - 외부 이미지/리소스 링크 사용 금지.
   - 모든 스타일은 인라인 CSS 또는 슬라이드 내부 클래스로 정의할 것.`,
        PROMPT_QUICKDOC_GEN: `너는 신속하고 정확한 비즈니스 문서 작성을 지원하는 AI 비서다.
[규칙]
- 모든 문서는 마크다운(Markdown) 형식을 기본으로 한다.
- 불필요한 서론/결론 없이 본론에 집중하라.
- 다국어 지원 시 원문의 뉘앙스를 최대한 살려 번역하라.`
    }
};

export function getAdminState() {
    let state = JSON.parse(JSON.stringify(defaultState));
    
    // Remove deprecated client-side keys. FreeLLMAPI keeps an explicit user-provided key for admin settings fallback.
    const rawStored = localStorage.getItem(ADMIN_STATE_KEY);
    if (rawStored) {
        try {
            const rawParsed = JSON.parse(rawStored);
            let hasKeys = false;
            ['geminiApiKey', 'openrouterApiKey', 'apiKey'].forEach(k => {
                if (rawParsed[k] !== undefined) {
                    delete rawParsed[k];
                    hasKeys = true;
                }
            });
            if (hasKeys) {
                localStorage.setItem(ADMIN_STATE_KEY, JSON.stringify(rawParsed));
            }
        } catch (e) {}
    }
    localStorage.removeItem('auraDoc_adminState_backup_ai_schema_v1');

    try {
        const stored = localStorage.getItem(ADMIN_STATE_KEY);
        if (stored) {
            let parsed;
            try {
                parsed = JSON.parse(stored);
            } catch (jsonErr) {
                console.error("[Migration Error] Failed to parse stored admin state. Preserving state for recovery.", jsonErr);
                throw jsonErr;
            }

            // ==================== SCHEMA V1 MIGRATION ====================
            if (!parsed.aiSettingsSchemaVersion || parsed.aiSettingsSchemaVersion < 1) {
                // 1. Back up original state
                localStorage.setItem('auraDoc_adminState_backup_ai_schema_v1', stored);
                console.log("[Migration] Original admin state backed up to auraDoc_adminState_backup_ai_schema_v1");

                // 2. Initialize new fields
                parsed.aiSettingsSchemaVersion = 1;
                parsed.routingMode = "fixed";
                parsed.activeModelKey = "gemini:gemini-1.5-flash"; // safe default fallback
                parsed.geminiApiKey = parsed.geminiApiKey || "";

                // 3. Normalize custom and existing models (De-duplicate by provider + modelCode)
                const existingModels = parsed.aiModels || [];
                const normalizedModelsMap = new Map();

                existingModels.forEach(m => {
                    const provider = m.provider || 'gemini';
                    const modelCode = m.modelCode || '';
                    if (!modelCode) return;
                    const compositeKey = `${provider}:${modelCode}`;

                    if (normalizedModelsMap.has(compositeKey)) {
                        const existing = normalizedModelsMap.get(compositeKey);
                        if (m.source === 'custom' && existing.source !== 'custom') {
                            normalizedModelsMap.set(compositeKey, m);
                        }
                    } else {
                        normalizedModelsMap.set(compositeKey, m);
                    }
                });

                // Convert remaining models, ensuring they have 'key', 'source', 'enabled'
                const migratedModels = Array.from(normalizedModelsMap.values()).map(m => {
                    const provider = m.provider || 'gemini';
                    const modelCode = m.modelCode || '';
                    return {
                        key: m.key || `${provider}:${modelCode}`,
                        name: m.name || modelCode,
                        provider,
                        endpoint: m.endpoint || 'default',
                        modelCode,
                        description: m.description || '',
                        source: m.source || 'custom',
                        enabled: m.enabled !== undefined ? m.enabled : true
                    };
                });

                // Remove 'auto' from the migrated model catalog
                parsed.aiModels = migratedModels.filter(m => m.modelCode !== 'auto');

                // 4. Resolve routingMode and activeModelKey from old activeModelId
                const oldActiveId = parsed.activeModelId;
                const activeModelInOldList = existingModels.find(m => String(m.id) === String(oldActiveId));

                if (activeModelInOldList) {
                    const prov = activeModelInOldList.provider;
                    const code = activeModelInOldList.modelCode;
                    if (prov === 'freellmapi' && code === 'auto') {
                        parsed.routingMode = "auto";
                        parsed.activeModelKey = null;
                    } else {
                        parsed.routingMode = "fixed";
                        parsed.activeModelKey = `${prov}:${code}`;
                    }
                } else {
                    if (parsed.aiProvider === 'freellmapi') {
                        parsed.routingMode = "auto";
                        parsed.activeModelKey = null;
                    } else {
                        parsed.routingMode = "fixed";
                        const defaultFirst = defaultState.aiModels.find(m => m.provider === parsed.aiProvider);
                        parsed.activeModelKey = defaultFirst ? defaultFirst.key : "gemini:gemini-1.5-flash";
                    }
                }

                // Clean up obsolete activeModelId
                delete parsed.activeModelId;

                localStorage.setItem(ADMIN_STATE_KEY, JSON.stringify(parsed));
                console.log("[Migration] Schema v1 migration completed successfully.", parsed);
            }
            // ==================== END MIGRATION ====================

            if (Array.isArray(parsed.permissions)) {
                const sanitizedPermissions = sanitizePermissionRows(parsed.permissions);
                if (JSON.stringify(sanitizedPermissions) !== JSON.stringify(parsed.permissions)) {
                    parsed.permissions = sanitizedPermissions;
                    localStorage.setItem(ADMIN_STATE_KEY, JSON.stringify(parsed));
                }
            }

            Object.keys(state).forEach(key => {
                if (parsed[key] !== undefined) {
                    if (key === 'prompts') {
                        state[key] = { ...state[key], ...parsed[key] };
                    } else if (key === 'aiModels') {
                        const loadedModels = parsed[key] || [];
                        const blendedMap = new Map();

                        defaultState.aiModels.forEach(dm => {
                            blendedMap.set(dm.key, { ...dm });
                        });

                        loadedModels.forEach(lm => {
                            if (lm.source === 'custom') {
                                blendedMap.set(lm.key, lm);
                            } else {
                                const existingBuiltin = blendedMap.get(lm.key);
                                if (existingBuiltin) {
                                    blendedMap.set(lm.key, {
                                        ...existingBuiltin,
                                        enabled: lm.enabled !== undefined ? lm.enabled : existingBuiltin.enabled,
                                        endpoint: lm.endpoint || existingBuiltin.endpoint,
                                        description: lm.description || existingBuiltin.description
                                    });
                                }
                            }
                        });

                        state[key] = Array.from(blendedMap.values());
                    } else {
                        state[key] = parsed[key];
                    }
                }
            });
        }
    } catch (e) {
        console.error("Admin state load failed:", e);
    }

    // Safeguard activeModelKey if fixed and inactive or invalid
    if (state.routingMode === 'fixed') {
        const activeM = state.aiModels.find(m => m.key === state.activeModelKey);
        if (!activeM || !activeM.enabled || activeM.provider !== state.aiProvider) {
            const firstValid = state.aiModels.find(m => m.provider === state.aiProvider && m.enabled);
            if (firstValid) {
                state.activeModelKey = firstValid.key;
            } else {
                const defaultFirst = defaultState.aiModels.find(m => m.provider === state.aiProvider);
                state.activeModelKey = defaultFirst ? defaultFirst.key : null;
            }
        }
    } else {
        state.activeModelKey = null;
    }
    
    state.permissions = sanitizePermissionRows(state.permissions);
    return state;
}

function sanitizePermissionRows(rows = []) {
    return (Array.isArray(rows) ? rows : []).filter(row => {
        const email = String(row.email || '').trim();
        const role = String(row.role || '').trim().toUpperCase();
        const status = String(row.status || '').trim();
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        const roleOk = ['ADMIN', 'EDITOR', 'VIEWER'].includes(role);
        return emailOk && roleOk && status;
    }).map(row => ({
        ...row,
        email: String(row.email || '').trim(),
        role: String(row.role || '').trim().toUpperCase(),
        status: String(row.status || '').trim()
    }));
}

function saveAdminState(state) {
    state.permissions = sanitizePermissionRows(state.permissions);
    localStorage.setItem(ADMIN_STATE_KEY, JSON.stringify(state));
    renderAdminTables();
    renderTemplates();
    window.dispatchEvent(new Event('adminStateChanged'));
}

export function openAdminModal() {
    // RBAC Guard - Bypassed for unified configuration access
    // Hide all main view containers for isolation
    const containers = ['dashboard-view', 'project-header', 'pipeline-proposal', 'pipeline-quickdoc', 'pipeline-sourcing'];
    containers.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
            el.classList.add('hidden');
            el.style.display = 'none';
        }
    });

    const settingsView = document.getElementById('settings-view');
    if (settingsView) {
        settingsView.classList.remove('hidden');
        settingsView.style.display = 'block';
    }
    
    document.getElementById('main-content').classList.remove('max-w-5xl');
    document.getElementById('main-content').classList.add('max-w-[1600px]');
    
    const activeTab = document.querySelector('.admin-tab.active') || document.querySelector('.admin-tab');
    if (activeTab) {
        switchAdminTab(activeTab.dataset.target, activeTab);
    }

    renderAdminTables();
    renderTemplates();
    loadAISettings();
    renderAiLogs();
}

export function closeAdminModal() {
    document.getElementById('settings-view').classList.add('hidden');
    document.getElementById('settings-view').style.display = 'none';
    
    // Restore the active pipeline mode view
    const state = appState.getState();
    window.dispatchEvent(new CustomEvent('auradoc:switchPipelineMode', { detail: { mode: state.activeMode || 'proposal' } }));
    
    document.getElementById('main-content').classList.add('max-w-5xl');
    document.getElementById('main-content').classList.remove('max-w-[1600px]');
}

export function switchAdminTab(targetId, btnElement) {
    console.log("[switchAdminTab] Called with targetId:", targetId, "btn:", btnElement?.dataset?.target);
    document.querySelectorAll('[id^="view-"]').forEach(el => {
        el.style.display = 'none';
        el.classList.add('hidden-view');
        el.style.opacity = '0';
    });
    const target = document.getElementById(targetId);
    if (target) {
        target.style.display = 'block';
        target.classList.remove('hidden-view');
        // Force Reflow
        void target.offsetWidth;
        target.style.opacity = '1';
        console.log("[switchAdminTab] Successfully set display:block and opacity:1 on target:", targetId);
    }

    document.querySelectorAll('.admin-tab').forEach(t => t.classList.remove('active', 'bg-white', 'shadow-sm', 'text-indigo-600'));
    if (btnElement) {
        btnElement.classList.add('active', 'bg-white', 'shadow-sm', 'text-indigo-600');
    }
    if (targetId === 'view-aiLogs') {
        renderAiLogs();
    }
    if (targetId === 'view-naverBlogConfig') {
        window.loadPersonalNaverConfig();
    }
    if (targetId === 'view-aiSettings') {
        refreshTranscriptHealth();
    }
    if (targetId === 'view-sourcingSettings') {
        loadSourcingConfig();
    }
    if (targetId === 'view-sourcingHistory') {
        loadSourcingHistory();
    }
    if (targetId === 'view-sourcingAgent') {
        loadSourcingAgentDashboard();
    }
}

// ============== CRUD for Tables ==============

function renderAdminTables() {
    const state = getAdminState();
    const tables = [
        { id: 'view-workModes', collection: 'workModes', fields: ['id', 'name', 'status'] },
        { id: 'view-documentTypes', collection: 'documentTypes', fields: ['id', 'name', 'prompt', 'template'] },
        { id: 'view-tones', collection: 'tones', fields: ['id', 'name', 'prompt'] },
        { id: 'view-audiences', collection: 'audiences', fields: ['id', 'name'] },
        { id: 'view-permissions', collection: 'permissions', fields: ['id', 'name', 'email', 'role', 'status'] }
    ];

    tables.forEach(table => {
        const tbody = document.querySelector(`#${table.id} tbody`);
        if (!tbody) return;

        const collection = table.collection;
        const collectionData = collection === 'permissions'
            ? getMergedPermissionRows(state)
            : (state[collection] || []);
        if (!Array.isArray(collectionData)) {
            tbody.innerHTML = '<tr><td colspan="10" class="text-center py-10 text-rose-400">데이터 형식이 올바르지 않습니다.</td></tr>';
            return;
        }

        let rowsHtml = collectionData.map(item => `
            <tr class="group border-b border-gray-50 hover:bg-slate-50 transition">
                <td class="text-center font-medium text-slate-300 py-4 text-xs">${item.id}</td>
                ${table.fields.slice(1).map(field => `
                    <td contenteditable="true" 
                        onblur="window.adminInlineUpdate('${collection}', '${item.id}', '${field}', this.innerText)"
                        onkeydown="if(event.key==='Enter'){event.preventDefault(); this.blur();}"
                        class="px-4 py-4 text-slate-700 outline-none focus:bg-white focus:ring-2 focus:ring-indigo-100 rounded-lg transition"
                    >${item[field] || ''}</td>
                `).join('')}
                <td class="text-center py-4">
                    <button class="w-8 h-8 flex items-center justify-center rounded-lg text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition mx-auto" onclick="window.adminDelete('${collection}', '${item.id}')">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                    </button>
                </td>
            </tr>
        `).join('');

        if (collection === 'permissions' && pendingPermissionDraft) {
            rowsHtml += `
                <tr class="bg-indigo-50/30 border-b border-indigo-100">
                    <td class="text-center font-black text-indigo-500 py-4 text-xs">신규</td>
                    ${table.fields.slice(1).map(field => `
                        <td contenteditable="true"
                            data-permission-draft-field="${field}"
                            onblur="window.adminUpdatePermissionDraft('${field}', this.innerText)"
                            onkeydown="if(event.key==='Enter'){event.preventDefault(); this.blur();}"
                            class="px-4 py-4 text-slate-700 outline-none focus:bg-white focus:ring-2 focus:ring-indigo-100 rounded-lg transition"
                        >${pendingPermissionDraft[field] || ''}</td>
                    `).join('')}
                    <td class="text-center py-4">
                        <div class="flex items-center justify-center gap-2">
                            <button class="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-[10px] font-black hover:bg-indigo-700" onclick="window.adminSavePermissionDraft()">저장</button>
                            <button class="px-3 py-1.5 rounded-lg bg-white text-slate-500 border border-slate-200 text-[10px] font-black hover:bg-slate-100" onclick="window.adminCancelPermissionDraft()">취소</button>
                        </div>
                    </td>
                </tr>
            `;
        }

        tbody.innerHTML = rowsHtml || '<tr><td colspan="10" class="text-center py-10 text-slate-400">등록된 데이터가 없습니다.</td></tr>';
    });
}

function getMergedPermissionRows(state) {
    const permissionRows = Array.isArray(state.permissions) ? [...state.permissions] : [];
    const seenEmails = new Set(permissionRows.map(row => String(row.email || '').trim().toLowerCase()).filter(Boolean));
    const currentUser = authService?.auth?.currentUser || authService?.currentUser || null;
    const isLocalMode = localStorage.getItem('localMode') === 'true';
    const currentEmail = currentUser?.email || (isLocalMode ? 'local@auradoc.dev' : '');

    if (currentEmail && !seenEmails.has(currentEmail.toLowerCase())) {
        const displayName = currentUser?.displayName || currentEmail.split('@')[0] || '현재 접속 사용자';
        const role = rbacController.getUserRole() === rbacController.roles.ADMIN ? 'ADMIN' : 'EDITOR';
        const numericIds = permissionRows
            .map(row => Number(row.id))
            .filter(id => Number.isFinite(id));
        permissionRows.push({
            id: numericIds.length ? Math.max(...numericIds) + 1 : 1,
            name: `${displayName} (현재 접속)`,
            email: currentEmail,
            role,
            status: isLocalMode ? '로컬 세션' : '인증 세션'
        });
    }

    return permissionRows;
}

window.adminAddRow = function (collection) {
    const state = getAdminState();
    if (collection === 'permissions') {
        pendingPermissionDraft = {
            name: '',
            email: '',
            role: 'EDITOR',
            status: '활성'
        };
        renderAdminTables();
        setTimeout(() => {
            document.querySelector('[data-permission-draft-field="name"]')?.focus();
        }, 0);
        return;
    }
    const newItem = { id: state[collection].length ? Math.max(...state[collection].map(i => i.id)) + 1 : 1 };

    if (collection === 'documentTypes') { newItem.name = "신규 문서"; newItem.prompt = ""; newItem.template = ""; }
    else if (collection === 'workModes') { newItem.name = "신규 모드"; newItem.status = "활성"; }
    else { newItem.name = "신규 항목"; if (collection === 'tones') newItem.prompt = ""; }

    state[collection].push(newItem);
    saveAdminState(state);
};

window.adminUpdatePermissionDraft = function (field, value) {
    if (!pendingPermissionDraft) return;
    pendingPermissionDraft[field] = String(value || '').trim();
};

window.adminSavePermissionDraft = function () {
    if (!pendingPermissionDraft) return;
    const draft = {
        name: String(pendingPermissionDraft.name || '').trim(),
        email: String(pendingPermissionDraft.email || '').trim(),
        role: String(pendingPermissionDraft.role || '').trim().toUpperCase(),
        status: String(pendingPermissionDraft.status || '').trim()
    };
    const errorEl = document.getElementById('permissions-inline-error');
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(draft.email);
    const roleOk = ['ADMIN', 'EDITOR', 'VIEWER'].includes(draft.role);

    if (!draft.name || !emailOk || !roleOk || !draft.status) {
        if (errorEl) {
            errorEl.classList.remove('hidden');
            errorEl.innerText = '이름, 유효한 이메일, 역할(ADMIN/EDITOR/VIEWER), 상태를 모두 입력해야 저장됩니다.';
        }
        return;
    }

    const state = getAdminState();
    const duplicate = (state.permissions || []).some(row => String(row.email || '').trim().toLowerCase() === draft.email.toLowerCase());
    if (duplicate) {
        if (errorEl) {
            errorEl.classList.remove('hidden');
            errorEl.innerText = '이미 같은 이메일의 권한 레코드가 있습니다.';
        }
        return;
    }

    const numericIds = (state.permissions || []).map(row => Number(row.id)).filter(Number.isFinite);
    state.permissions = [...(state.permissions || []), {
        id: numericIds.length ? Math.max(...numericIds) + 1 : 1,
        ...draft
    }];
    pendingPermissionDraft = null;
    if (errorEl) errorEl.classList.add('hidden');
    saveAdminState(state);
};

window.adminCancelPermissionDraft = function () {
    pendingPermissionDraft = null;
    const errorEl = document.getElementById('permissions-inline-error');
    if (errorEl) errorEl.classList.add('hidden');
    renderAdminTables();
};

window.adminInlineUpdate = function (collection, id, field, value) {
    const state = getAdminState();
    const item = state[collection].find(i => String(i.id) === String(id));
    if (item && item[field] !== value) {
        item[field] = value.trim();
        saveAdminState(state);
    }
};

window.adminDelete = function (collection, id) {
    if (!confirm('삭제하시겠습니까?')) return;
    const state = getAdminState();
    state[collection] = state[collection].filter(i => String(i.id) !== String(id));
    saveAdminState(state);
};

// ============== AI Catalog Pagination & Filters State ==============
let catalogCurrentPage = 1;
const catalogPageSize = 20;
let pendingPermissionDraft = null;

let catalogProviderFilter = 'all';
let catalogStatusFilter = 'all';
let catalogSearchQuery = '';

window.adminFilterCatalog = function () {
    catalogCurrentPage = 1;
    renderModelCatalog();
};

window.adminCatalogPrevPage = function () {
    if (catalogCurrentPage > 1) {
        catalogCurrentPage--;
        renderModelCatalog();
    }
};

window.adminCatalogNextPage = function () {
    const state = getAdminState();
    const filtered = filterCatalogModels(state.aiModels);
    const totalPages = Math.ceil(filtered.length / catalogPageSize) || 1;
    if (catalogCurrentPage < totalPages) {
        catalogCurrentPage++;
        renderModelCatalog();
    }
};

function filterCatalogModels(models) {
    const providerEl = document.getElementById('catalog-provider-filter');
    const statusEl = document.getElementById('catalog-status-filter');
    const searchEl = document.getElementById('catalog-search-input');
    
    catalogProviderFilter = providerEl ? providerEl.value : 'all';
    catalogStatusFilter = statusEl ? statusEl.value : 'all';
    catalogSearchQuery = searchEl ? searchEl.value.trim().toLowerCase() : '';

    return models.filter(m => {
        const matchesProvider = catalogProviderFilter === 'all' || m.provider === catalogProviderFilter;
        
        let matchesStatus = true;
        if (catalogStatusFilter === 'enabled') matchesStatus = m.enabled === true;
        else if (catalogStatusFilter === 'disabled') matchesStatus = m.enabled === false;

        const matchesSearch = !catalogSearchQuery || 
            (m.name || '').toLowerCase().includes(catalogSearchQuery) || 
            (m.modelCode || '').toLowerCase().includes(catalogSearchQuery) ||
            (m.description || '').toLowerCase().includes(catalogSearchQuery);

        return matchesProvider && matchesStatus && matchesSearch;
    });
}

function renderModelCatalog() {
    const state = getAdminState();
    const tbody = document.getElementById('catalog-tbody');
    if (!tbody) return;

    const filtered = filterCatalogModels(state.aiModels);
    const totalPages = Math.ceil(filtered.length / catalogPageSize) || 1;
    if (catalogCurrentPage > totalPages) catalogCurrentPage = totalPages;

    const startIdx = (catalogCurrentPage - 1) * catalogPageSize;
    const paginated = filtered.slice(startIdx, startIdx + catalogPageSize);

    const countEl = document.getElementById('catalog-count-label');
    if (countEl) {
        countEl.innerText = `검색 결과: ${filtered.length}개 모델`;
    }

    const pageEl = document.getElementById('catalog-page-label');
    if (pageEl) {
        pageEl.innerText = `페이지 ${catalogCurrentPage} / ${totalPages}`;
    }

    const prevBtn = document.getElementById('catalog-prev-page');
    const nextBtn = document.getElementById('catalog-next-page');
    if (prevBtn) prevBtn.disabled = catalogCurrentPage <= 1;
    if (nextBtn) nextBtn.disabled = catalogCurrentPage >= totalPages;

    tbody.innerHTML = paginated.map(m => {
        const isCurrentActive = state.routingMode === 'fixed' && state.activeModelKey === m.key;
        const typeBadge = m.source === 'builtin' 
            ? `<span class="px-2.5 py-1 rounded-full text-[10px] font-bold bg-indigo-50 text-indigo-600 border border-indigo-100">Builtin</span>`
            : `<span class="px-2.5 py-1 rounded-full text-[10px] font-bold bg-amber-50 text-amber-600 border border-amber-100">Custom</span>`;

        const activeBadge = isCurrentActive 
            ? `<div class="mt-1"><span class="px-1.5 py-0.5 rounded text-[8px] font-black bg-emerald-500 text-white animate-pulse">적용 중</span></div>`
            : '';

        let statusBadge = '';
        const isExpired = m.verificationExpiresAt && Date.now() > new Date(m.verificationExpiresAt).getTime();
        if (m.unavailable) {
            statusBadge = `<div class="mt-1"><span class="px-1.5 py-0.5 rounded text-[8px] font-bold bg-rose-100 text-rose-700 border border-rose-200">사용 불가 ⚠️</span></div>`;
        } else if (isExpired) {
            statusBadge = `<div class="mt-1"><span class="px-1.5 py-0.5 rounded text-[8px] font-bold bg-amber-100 text-amber-700 border border-amber-200" title="만료시각: ${m.verificationExpiresAt}">검증 만료 ⚠️</span></div>`;
        } else if (m.verifiedAt) {
            try {
                const date = new Date(m.verifiedAt);
                const timeStr = date.toLocaleTimeString();
                statusBadge = `<div class="mt-1"><span class="px-1.5 py-0.5 rounded text-[8px] font-bold bg-emerald-100 text-emerald-700 border border-emerald-200" title="검증시각: ${m.verifiedAt}">검증됨 (${timeStr})</span></div>`;
            } catch (de) {}
        }

        const deleteButton = m.source === 'custom'
            ? `<button onclick="window.adminDeleteAIModel('${m.key}')" class="w-8 h-8 flex items-center justify-center rounded-lg text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition mx-auto" title="삭제">
                   <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
               </button>`
            : `<span class="text-[10px] text-slate-300 font-bold">삭제 불가</span>`;

        const toggleChecked = m.enabled ? 'checked' : '';

        return `
            <tr class="group hover:bg-slate-50/50 transition">
                <td class="px-4 py-3.5 font-bold text-slate-800">
                    <div contenteditable="${m.source === 'custom'}" 
                         onblur="window.adminUpdateAIModel('${m.key}', 'name', this.innerText)"
                         class="outline-none focus:bg-white focus:ring-2 focus:ring-indigo-100 rounded p-1 transition"
                     >${m.name}</div>
                    ${activeBadge}
                    ${statusBadge}
                </td>
                <td class="px-4 py-3.5 text-center font-bold text-slate-500 uppercase tracking-wider">${m.provider}</td>
                <td class="px-4 py-3.5 font-mono text-slate-600 text-xs">
                    <div contenteditable="${m.source === 'custom'}" 
                         onblur="window.adminUpdateAIModel('${m.key}', 'modelCode', this.innerText)"
                         class="outline-none focus:bg-white focus:ring-2 focus:ring-indigo-100 rounded p-1 transition"
                    >${m.modelCode}</div>
                </td>
                <td class="px-4 py-3.5 text-slate-500">
                    <div contenteditable="true" 
                         onblur="window.adminUpdateAIModel('${m.key}', 'description', this.innerText)"
                         class="outline-none focus:bg-white focus:ring-2 focus:ring-indigo-100 rounded p-1 transition"
                    >${m.description || ''}</div>
                    ${m.source === 'custom' ? `
                    <div class="mt-1 text-[10px] font-mono text-slate-400 flex items-center gap-1">
                        <span>Endpoint:</span>
                        <input type="text" value="${m.endpoint}" 
                               onblur="window.adminUpdateAIModel('${m.key}', 'endpoint', this.value)"
                               class="bg-transparent border-b border-transparent focus:border-slate-300 focus:bg-white outline-none px-1 text-[10px] text-slate-500 w-full font-mono transition">
                    </div>` : ''}
                </td>
                <td class="px-4 py-3.5 text-center">${typeBadge}</td>
                <td class="px-4 py-3.5 text-center">
                    <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" ${toggleChecked} 
                               onchange="window.adminToggleAIModel('${m.key}', this.checked)"
                               class="sr-only peer">
                        <div class="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600"></div>
                    </label>
                </td>
                <td class="px-4 py-3.5 text-center">${deleteButton}</td>
            </tr>
        `;
    }).join('');
}

window.adminToggleAIModel = function (key, enabled) {
    const state = getAdminState();
    
    if (!enabled && state.routingMode === 'fixed' && state.activeModelKey === key) {
        alert("현재 사용 중인 모델입니다. 다른 모델을 먼저 적용하세요.");
        renderModelCatalog();
        return;
    }

    const model = state.aiModels.find(m => m.key === key);
    if (model) {
        model.enabled = enabled;
        saveAdminState(state);
    }
};

window.adminDeleteAIModel = function (key) {
    const state = getAdminState();
    const model = state.aiModels.find(m => m.key === key);
    if (!model) return;

    if (model.source !== 'custom') {
        alert("기본(Builtin) 모델은 삭제할 수 없습니다.");
        return;
    }

    if (state.routingMode === 'fixed' && state.activeModelKey === key) {
        alert("현재 사용 중인 모델입니다. 다른 모델을 먼저 적용하세요.");
        return;
    }

    if (!confirm(`'${model.name}' 모델을 정말 삭제하시겠습니까?`)) return;

    state.aiModels = state.aiModels.filter(m => m.key !== key);
    saveAdminState(state);
};

window.adminAddAIModel = function () {
    const nameEl = document.getElementById('add-model-name');
    const providerEl = document.getElementById('add-model-provider');
    const codeEl = document.getElementById('add-model-code');
    const endpointEl = document.getElementById('add-model-endpoint');
    const descEl = document.getElementById('add-model-desc');
    const errorEl = document.getElementById('add-model-error-alert');

    if (errorEl) {
        errorEl.classList.add('hidden');
        errorEl.innerText = '';
    }

    const name = nameEl ? nameEl.value.trim() : '';
    const provider = providerEl ? providerEl.value : 'gemini';
    const code = codeEl ? codeEl.value.trim() : '';
    const endpoint = endpointEl && endpointEl.value.trim() ? endpointEl.value.trim() : 'default';
    const description = descEl ? descEl.value.trim() : '';

    if (!name || !code) {
        if (errorEl) {
            errorEl.innerText = '모델 명칭과 모델 코드는 필수 입력 항목입니다.';
            errorEl.classList.remove('hidden');
        }
        return;
    }

    const state = getAdminState();
    const duplicate = state.aiModels.find(m => m.provider === provider && m.modelCode === code);
    if (duplicate) {
        if (errorEl) {
            errorEl.innerText = `이미 등록된 제공자(${provider})와 모델코드(${code}) 조합입니다.`;
            errorEl.classList.remove('hidden');
        }
        return;
    }

    const key = `${provider}:${code}`;
    const newModel = {
        key,
        name,
        provider,
        endpoint,
        modelCode: code,
        description,
        source: 'custom',
        enabled: true
    };

    state.aiModels.push(newModel);
    saveAdminState(state);

    if (nameEl) nameEl.value = '';
    if (codeEl) codeEl.value = '';
    if (endpointEl) endpointEl.value = '';
    if (descEl) descEl.value = '';
};

window.adminUpdateAIModel = function (key, field, value) {
    const state = getAdminState();
    const model = state.aiModels.find(m => m.key === key);
    if (model) {
        const cleanVal = value.trim();
        if (model[field] !== cleanVal) {
            if (field === 'modelCode' && model.source === 'custom') {
                const oldKey = model.key;
                const newKey = `${model.provider}:${cleanVal}`;
                
                if (state.aiModels.some(m => m.key === newKey && m.key !== oldKey)) {
                    alert("동일한 제공자와 모델코드 조합이 이미 존재합니다.");
                    renderModelCatalog();
                    return;
                }
                
                model.modelCode = cleanVal;
                model.key = newKey;

                if (state.activeModelKey === oldKey) {
                    state.activeModelKey = newKey;
                }
            } else {
                model[field] = cleanVal;
            }
            saveAdminState(state);
        }
    }
};

// ============== Template Management ==============

let currentEditingTemplateId = null;

function renderTemplates() {
    const state = getAdminState();
    const container = document.getElementById('admin-template-list');
    const select = document.getElementById('admin-template-select');
    if (!container && !select) return;

    if (select) {
        select.innerHTML = state.templates.map(t => `
            <option value="${t.id}" ${currentEditingTemplateId === t.id ? 'selected' : ''}>${t.name} (${t.type})</option>
        `).join('');
    }

    if (container) {
        container.innerHTML = state.templates.map(t => `
            <div onclick="window.adminSelectTemplate(${t.id})" class="p-4 rounded-xl cursor-pointer transition border-2 ${currentEditingTemplateId === t.id ? 'border-indigo-500 bg-indigo-50/50' : 'border-slate-100 bg-white hover:border-indigo-200'}">
                <p class="font-bold text-slate-800 text-sm">${t.name}</p>
                <p class="text-[10px] text-slate-400 mt-1 uppercase font-bold tracking-wider">${t.type} • ${t.size}</p>
            </div>
        `).join('');
    }

    if (!currentEditingTemplateId && state.templates.length > 0) {
        // Only auto-select if we're not explicitly adding a new one
        if (container && container.dataset.isAdding !== 'true') {
            window.adminSelectTemplate(state.templates[0].id, true); // true to prevent re-rendering the list
        }
    }
}

window.adminSelectTemplate = function (id, preventRender = false) {
    currentEditingTemplateId = id;
    const state = getAdminState();
    const t = state.templates.find(tpl => tpl.id === id);
    if (!t) return;

    document.getElementById('tpl-name').value = t.name || "";
    document.getElementById('tpl-type').value = t.type || "제안서";
    document.getElementById('tpl-css').value = t.css || "";
    document.getElementById('tpl-html').value = t.html || "";

    if (!preventRender) renderTemplates();
    window.adminUpdateTemplatePreview();
};

window.adminUpdateTemplatePreview = function () {
    const css = document.getElementById('tpl-css').value;
    const html = document.getElementById('tpl-html').value;
    const previewContainer = document.getElementById('tpl-preview-box');
    if (!previewContainer) return;

    const srcDoc = `<!DOCTYPE html><html><head><style>body{margin:0;padding:0;overflow:hidden;background:#f8fafc;display:flex;justify-content:center;align-items:center;height:100vh;} .preview-slide{width:100%;height:100%;overflow:auto;background:white;} ${css}</style></head><body><div class="preview-slide">${html}</div></body></html>`;
    previewContainer.innerHTML = `<iframe srcdoc="${srcDoc.replace(/"/g, '&quot;')}" style="width:100%; height:100%; border:none;"></iframe>`;
};

window.adminSaveTemplate = function () {
    const state = getAdminState();
    const name = document.getElementById('tpl-name').value;
    if (!name) return alert("템플릿 이름을 입력하세요.");

    const tplData = {
        id: currentEditingTemplateId || Date.now(),
        name: name,
        type: document.getElementById('tpl-type').value,
        size: "반응형 (Auto)",
        css: document.getElementById('tpl-css').value,
        html: document.getElementById('tpl-html').value
    };

    if (currentEditingTemplateId) {
        const idx = state.templates.findIndex(t => t.id === currentEditingTemplateId);
        state.templates[idx] = tplData;
    } else {
        state.templates.push(tplData);
        currentEditingTemplateId = tplData.id;
    }

    saveAdminState(state);
    const container = document.getElementById('admin-template-list');
    if (container) container.dataset.isAdding = 'false';
    alert("템플릿이 저장되었습니다.");
};

window.adminAddTemplate = function () {
    currentEditingTemplateId = null;
    const container = document.getElementById('admin-template-list');
    if (container) container.dataset.isAdding = 'true';

    document.getElementById('tpl-name').value = "새 템플릿";
    document.getElementById('tpl-type').value = "제안서";
    document.getElementById('tpl-css').value = "";
    document.getElementById('tpl-html').value = '<div class="slide"></div>';
    renderTemplates();
    window.adminUpdateTemplatePreview();
};

window.adminDeleteTemplate = function () {
    if (!currentEditingTemplateId) return;
    if (!confirm("정말 삭제하시겠습니까?")) return;
    const state = getAdminState();
    state.templates = state.templates.filter(t => t.id !== currentEditingTemplateId);
    currentEditingTemplateId = null;
    saveAdminState(state);
    renderTemplates();
};

window.adminOpenVisionUpload = function () {
    document.getElementById('admin-vision-upload')?.click();
};

window.adminHandleVisionUpload = async function (input) {
    if (!input.files || !input.files[0]) return;
    const file = input.files[0];

    // Check if the current AI provider supports vision (Gemini or OpenRouter usually do)
    const state = getAdminState();
    if (state.aiProvider === 'local') {
        alert("로컬 모델(Ollama)은 현재 Vision 기능을 지원하지 않습니다. OpenRouter 또는 Gemini를 사용해 주세요.");
        return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
        const base64 = e.target.result;

        const loader = document.getElementById('global-loader');
        const lTitle = document.getElementById('loader-title');
        const lDesc = document.getElementById('loader-desc');

        if (loader) {
            lTitle.innerText = "AI Vision 분석";
            lDesc.innerText = "이미지에서 템플릿 구조를 추출하고 있습니다...";
            loader.classList.remove('modal-hidden');
        }

        try {
            const { aiService } = await import('../services/aiService.js');
            const result = await aiService.callVisionAI(base64);

            if (!result) throw new Error("AI가 응답을 생성하지 못했습니다.");

            // Extract CSS and HTML from AI response
            const cssMatch = result.match(/<style>([\s\S]*?)<\/style>/i) || result.match(/```css\s*([\s\S]*?)```/i);
            const htmlMatch = result.match(/<body>([\s\S]*?)<\/body>/i) || result.match(/```html\s*([\s\S]*?)```/i);

            let css = cssMatch ? cssMatch[1].trim() : "";
            let html = htmlMatch ? htmlMatch[1].trim() : result;

            if (!css && !html.includes('<div')) {
                // If no clear blocks, try to split if it's just raw code
                const parts = result.split(/```/);
                if (parts.length >= 2) {
                    html = parts[1].replace(/html/i, '').trim();
                    if (parts.length >= 4) css = parts[3].replace(/css/i, '').trim();
                }
            }

            // Create new template
            window.adminAddTemplate();
            document.getElementById('tpl-name').value = `Vision Generated (${file.name})`;
            document.getElementById('tpl-css').value = css || "/* AI가 CSS를 추출하지 못했습니다. 직접 입력해주세요. */";
            document.getElementById('tpl-html').value = html || "<!-- AI가 HTML을 추출하지 못했습니다. 직접 입력해주세요. -->";

            window.adminUpdateTemplatePreview();
            alert("AI가 이미지를 분석하여 템플릿 초안을 생성했습니다. [저장] 버튼을 눌러 확정하세요.");
        } catch (error) {
            console.error("Vision Upload Failed:", error);
            alert("Vision 분석 실패: " + error.message);
        } finally {
            if (loader) loader.classList.add('modal-hidden');
            input.value = ""; // Reset file input
        }
    };
    reader.readAsDataURL(file);
};

// ============== AI Settings ==============

function loadAISettings() {
    try {
        const state = getAdminState();
        
        // Populate inputs
        const provSel = document.getElementById('admin-ai-provider');
        if (provSel) {
            // Set providers options dynamically to ensure options exist
            provSel.innerHTML = `
                <option value="gemini">Google Gemini</option>
                <option value="local">Ollama</option>
                <option value="openrouter">OpenRouter</option>
                <option value="freellmapi">FreeLLMAPI</option>
            `;
            provSel.value = state.aiProvider || 'gemini';
        }

        const openrouterKey = document.getElementById('admin-openrouter-key');
        if (openrouterKey) openrouterKey.value = state.openrouterApiKey || '';

        const freellmUrl = document.getElementById('admin-freellm-url');
        if (freellmUrl) freellmUrl.value = state.freellmUrl || '';

        const freellmKey = document.getElementById('admin-freellm-key');
        if (freellmKey) freellmKey.value = state.freellmApiKey || '';

        const geminiKey = document.getElementById('admin-gemini-key');
        if (geminiKey) geminiKey.value = state.geminiApiKey || '';

        // Bind routingMode radios
        const radioAuto = document.getElementById('radio-mode-auto');
        const radioFixed = document.getElementById('radio-mode-fixed');
        if (radioAuto && radioFixed) {
            if (state.routingMode === 'auto') {
                radioAuto.checked = true;
            } else {
                radioFixed.checked = true;
            }
        }

        // Toggle UI visibilities
        window.adminOnProviderChange(true); // prevent active key overwrite during load
        renderModelCatalog();
        updateConnectionCard();

        window.adminFormChanged = false;
        bindFormChangeListeners();
    } catch (err) {
        console.error("[loadAISettings] Error loading AI settings:", err);
    }
}

function bindFormChangeListeners() {
    if (window.formChangeListenersBound) return;
    window.formChangeListenersBound = true;
    
    const monitoredFields = [
        'admin-ai-provider',
        'admin-ai-model-select',
        'admin-openrouter-key',
        'admin-freellm-url',
        'admin-freellm-key',
        'admin-gemini-key',
        'radio-mode-auto',
        'radio-mode-fixed'
    ];

    const markFormChanged = (e) => {
        if (e.target && monitoredFields.includes(e.target.id)) {
            window.adminFormChanged = true;
        }
    };

    document.addEventListener('change', markFormChanged);
    document.addEventListener('input', markFormChanged);
}

function setTestButtonsState(testing) {
    const btnTest = document.querySelector('button[onclick="window.adminTestConnection()"]');
    const btnSaveTest = document.getElementById('admin-save-test-btn');
    const btnSave = document.getElementById('admin-save-ai-settings-btn');

    [btnTest, btnSaveTest, btnSave].forEach(btn => {
        if (btn) {
            if (testing) {
                btn.disabled = true;
                btn.setAttribute('aria-disabled', 'true');
                btn.classList.add('opacity-50', 'cursor-not-allowed');
            } else {
                btn.disabled = false;
                btn.removeAttribute('aria-disabled');
                btn.classList.remove('opacity-50', 'cursor-not-allowed');
            }
        }
    });

    if (btnTest) {
        btnTest.innerText = testing ? '테스트 중...' : '연결 테스트';
    }
    if (btnSaveTest) {
        btnSaveTest.innerText = testing ? '테스트 중...' : '저장 후 연결 테스트';
    }
}

window.adminOnProviderChange = function (preventKeyReset = false) {
    try {
        const provSel = document.getElementById('admin-ai-provider');
        if (!provSel) return;
        const provider = provSel.value;

        // Toggle API containers
        document.getElementById('admin-openrouter-key-container')?.classList.toggle('hidden', provider !== 'openrouter');
        document.getElementById('admin-freellm-container')?.classList.toggle('hidden', provider !== 'freellmapi');
        document.getElementById('admin-gemini-key-container')?.classList.toggle('hidden', provider !== 'gemini');

        // Keep routing controls provider-neutral. FreeLLMAPI supports requestedModel: "auto" at the service layer.
        const radioAuto = document.getElementById('radio-mode-auto');
        const labelAuto = document.getElementById('label-mode-auto');
        const textAuto = document.getElementById('text-mode-auto');

        if (radioAuto) {
            radioAuto.disabled = false;
        }
        if (labelAuto) {
            labelAuto.className = "inline-flex items-center gap-2 text-xs font-bold text-slate-700 cursor-pointer";
        }
        if (textAuto) {
            textAuto.innerHTML = '자동 라우팅 (Auto)';
        }

        window.adminRefreshModelSelect(preventKeyReset);
        window.adminOnSelectModeChange();
    } catch (err) {
        console.error("[adminOnProviderChange] Error:", err);
    }
};

window.adminOnSelectModeChange = function () {
    try {
        const radioAuto = document.getElementById('radio-mode-auto');
        const isAuto = radioAuto && radioAuto.checked;
        
        // Hide model selector if in auto routing mode
        const selectContainer = document.getElementById('admin-model-select-container');
        if (selectContainer) {
            selectContainer.classList.toggle('hidden', !!isAuto);
        }
    } catch (err) {
        console.error("[adminOnSelectModeChange] Error:", err);
    }
};

window.adminRefreshModelSelect = function (preventKeyReset = false) {
    try {
        const provSel = document.getElementById('admin-ai-provider');
        if (!provSel) return;
        const provider = provSel.value;

        const modelSel = document.getElementById('admin-ai-model-select');
        const state = getAdminState();

        if (modelSel) {
            // Only list ENABLED models of the selected provider.
            let filtered = state.aiModels.filter(m =>
                m.provider === provider && m.enabled
            );

            modelSel.innerHTML = filtered.map(m => {
                const isExpired = m.verificationExpiresAt && Date.now() > new Date(m.verificationExpiresAt).getTime();
                const staleLabel = isExpired ? " [검증 만료 ⚠️]" : "";
                const label = m.unavailable 
                    ? `${m.name} (${m.modelCode}) [사용 불가 ⚠️]` 
                    : `${m.name} (${m.modelCode})${staleLabel}`;
                return `<option value="${m.key}">${label}</option>`;
            }).join('');

            if (preventKeyReset && state.activeModelKey && state.activeModelKey.startsWith(provider + ':')) {
                const stillExists = filtered.find(m => m.key === state.activeModelKey);
                if (stillExists) {
                    modelSel.value = state.activeModelKey;
                    return;
                }
            }
            
            if (filtered.length > 0) {
                modelSel.value = filtered[0].key;
            }
        }
    } catch (err) {
        console.error("[adminRefreshModelSelect] Error refreshing models:", err);
    }
};

window.adminSaveAISettings = async function (silent = false) {
    try {
        const state = getAdminState();
        const providerEl = document.getElementById('admin-ai-provider');
        const modelSel = document.getElementById('admin-ai-model-select');
        const radioAuto = document.getElementById('radio-mode-auto');

        if (!providerEl) {
            console.error("Admin: AI provider element not found.");
            return false;
        }

        const provider = providerEl.value;
        const isAuto = radioAuto && radioAuto.checked && provider === 'freellmapi';

        state.aiProvider = provider;
        state.routingMode = isAuto ? 'auto' : 'fixed';

        if (!isAuto) {
            if (!modelSel || !modelSel.value) {
                alert("활성 AI 모델을 지정해야 합니다. 먼저 활성화된 모델을 모델 카탈로그에서 체크하거나 추가하세요.");
                return false;
            }
            state.activeModelKey = modelSel.value;
        } else {
            state.activeModelKey = null;
        }

        state.openrouterApiKey = '';
        state.freellmUrl = document.getElementById('admin-freellm-url')?.value.trim() || '';
        state.freellmApiKey = document.getElementById('admin-freellm-key')?.value.trim() || '';
        state.geminiApiKey = '';

        // Backwards compatibility sync for OCI/ollama config
        if (!isAuto && state.activeModelKey) {
            const activeModel = state.aiModels.find(m => m.key === state.activeModelKey);
            if (activeModel) {
                state.ollamaUrl = activeModel.endpoint;
                state.ollamaModel = activeModel.modelCode;
            }
        } else if (isAuto) {
            state.ollamaModel = 'auto';
        }

        saveAdminState(state);
        window.adminFormChanged = false; // Reset changed flag after successful save

        if (!silent) alert("AI 실행 설정이 성공적으로 저장되었습니다.");
        
        updateConnectionCard();
        renderModelCatalog();
        return true;
    } catch (err) {
        console.error("Admin: Failed to save AI settings:", err);
        alert("설정 저장 중 오류가 발생했습니다: " + err.message);
        return false;
    }
};

window.adminSaveAndTestConnection = async function () {
    const saved = await window.adminSaveAISettings(true);
    if (!saved) return;
    await runConnectionTestDirectly();
};

async function updateConnectionCard() {
    try {
        const state = getAdminState();
        
        const provEl = document.getElementById('conn-provider-label');
        const policyEl = document.getElementById('conn-policy-label');
        const reqEl = document.getElementById('conn-req-model-label');
        const epEl = document.getElementById('conn-endpoint-label');
        
        if (provEl) provEl.innerText = state.aiProvider ? state.aiProvider.toUpperCase() : '-';
        if (policyEl) policyEl.innerText = state.routingMode === 'auto' ? '자동 라우팅 (Auto)' : '고정 모델 (Fixed)';
        
        if (reqEl) {
            if (state.routingMode === 'auto') {
                reqEl.innerText = 'auto';
            } else if (state.activeModelKey) {
                const m = state.aiModels.find(item => item.key === state.activeModelKey);
                reqEl.innerText = m ? `${m.name} (${m.modelCode})` : state.activeModelKey;
            } else {
                reqEl.innerText = '-';
            }
        }
        
        if (epEl) {
            if (state.routingMode === 'fixed' && state.activeModelKey) {
                const m = state.aiModels.find(item => item.key === state.activeModelKey);
                epEl.innerText = m ? m.endpoint : 'default';
            } else {
                epEl.innerText = state.freellmUrl || 'default';
            }
        }

        // Fetch logs to show most recent successful call data
        const logs = JSON.parse(localStorage.getItem('auraDoc_connectionLogs') || '[]');
        const successLog = logs.find(l => l.success === true);
        
        const respEl = document.getElementById('conn-resp-model-label');
        const timeEl = document.getElementById('conn-last-success-label');
        
        if (respEl) respEl.innerText = successLog ? (successLog.resolvedModel || '-') : '-';
        if (timeEl) {
            if (successLog && successLog.timestamp) {
                const date = new Date(successLog.timestamp);
                timeEl.innerText = date.toLocaleTimeString();
            } else {
                timeEl.innerText = '-';
            }
        }
    } catch (e) {
        console.error("Error updating connection card:", e);
    }
}

window.adminTestConnection = async function () {
    if (window.adminFormChanged) {
        const alertEl = document.getElementById('conn-test-result-alert');
        if (alertEl) {
            alertEl.className = 'p-4 rounded-xl text-xs font-bold bg-amber-50 text-amber-700';
            alertEl.innerText = "⚠️ 변경사항 저장 필요: 현재 입력된 변경사항이 존재하여 테스트를 진행할 수 없습니다. '설정 저장' 또는 '저장 후 연결 테스트'를 눌러 진행해 주십시오.";
            alertEl.classList.remove('hidden');
        }
        return;
    }
    await runConnectionTestDirectly();
};

async function refreshTranscriptHealth() {
    const okEl = document.getElementById('transcript-health-ok');
    const proxyEl = document.getElementById('transcript-health-proxy');
    const asrEl = document.getElementById('transcript-health-asr');
    const checkedEl = document.getElementById('transcript-health-checked');
    const messageEl = document.getElementById('transcript-health-message');

    if (okEl) okEl.innerText = '확인 중...';
    if (messageEl) {
        messageEl.className = 'p-4 rounded-xl text-xs font-bold bg-slate-50 text-slate-600';
        messageEl.innerText = 'YouTube 대사 추출 서비스 상태를 확인하고 있습니다.';
        messageEl.classList.remove('hidden');
    }

    try {
        const response = await fetch('/api/transcript-health', { cache: 'no-store' });
        const data = await response.json().catch(() => ({}));
        const ok = response.ok && data.ok === true;

        if (okEl) {
            okEl.innerText = ok ? '정상' : '점검 필요';
            okEl.className = `font-bold ${ok ? 'text-emerald-700' : 'text-rose-700'}`;
        }
        if (proxyEl) {
            proxyEl.innerText = data.proxyConfigured ? '적용됨' : '미적용';
            proxyEl.className = `font-bold ${data.proxyConfigured ? 'text-emerald-700' : 'text-amber-700'}`;
        }
        if (asrEl) {
            asrEl.innerText = data.asrConfigured ? '사용 가능' : '보류';
            asrEl.className = `font-bold ${data.asrConfigured ? 'text-emerald-700' : 'text-slate-500'}`;
        }
        if (checkedEl) checkedEl.innerText = new Date().toLocaleTimeString();
        if (messageEl) {
            messageEl.className = `p-4 rounded-xl text-xs font-bold ${ok ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700'}`;
            messageEl.innerText = ok
                ? '✅ transcript 서비스가 응답 중입니다. 공개 자막이 있는 영상은 자동 추출을 시도합니다.'
                : `❌ transcript 서비스 확인 실패: ${data.error || data.message || response.status}`;
        }
    } catch (error) {
        if (okEl) {
            okEl.innerText = '연결 실패';
            okEl.className = 'font-bold text-rose-700';
        }
        if (checkedEl) checkedEl.innerText = new Date().toLocaleTimeString();
        if (messageEl) {
            messageEl.className = 'p-4 rounded-xl text-xs font-bold bg-rose-50 text-rose-700';
            messageEl.innerText = `❌ transcript 헬스 체크 요청 실패: ${error.message}`;
            messageEl.classList.remove('hidden');
        }
    }
}

window.adminRefreshTranscriptHealth = refreshTranscriptHealth;

async function runConnectionTestDirectly() {
    const alertEl = document.getElementById('conn-test-result-alert');
    const statusEl = document.getElementById('conn-status-label');
    let diagnostics = {
        provider: 'N/A',
        requestedModel: 'N/A'
    };
    
    if (alertEl) {
        alertEl.classList.remove('hidden', 'bg-emerald-50', 'text-emerald-700', 'bg-rose-50', 'text-rose-700');
        alertEl.classList.add('bg-slate-50', 'text-slate-600');
        alertEl.innerText = '연결 상태 진단 중... 잠시만 기다려주세요.';
        alertEl.classList.remove('hidden');
    }
    if (statusEl) statusEl.innerText = '테스트 중...';

    setTestButtonsState(true);

    try {
        const state = getAdminState();

        // Key presence check is bypassed since credentials are resolved strictly on the backend proxy

        const { aiService } = await import('../services/aiService.js');
        const execConfig = aiService.resolveAIExecutionConfig(state);
        diagnostics = {
            provider: execConfig.provider || state.aiProvider || 'N/A',
            requestedModel: execConfig.requestedModel || 'N/A'
        };
        
        // Single connection test request (no loops)
        const testRes = await aiService.testConnection(execConfig);

        if (testRes.success) {
            if (statusEl) statusEl.innerText = '연결됨';
            if (alertEl) {
                alertEl.className = 'p-4 rounded-xl text-xs font-bold bg-emerald-50 text-emerald-700';
                alertEl.innerText = `✅ 연결 성공: AI 서비스와 원활하게 통신 중입니다. (지연시간: ${testRes.latency}ms)`;
            }

            // Lifecycle: update verifiedAt, verificationExpiresAt, and reset failure counts
            if (state.activeModelKey) {
                const modelIdx = state.aiModels.findIndex(m => m.key === state.activeModelKey);
                if (modelIdx !== -1) {
                    const m = state.aiModels[modelIdx];
                    m.verifiedAt = new Date().toISOString();
                    m.verificationExpiresAt = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(); // 24 Hours TTL
                    m.unavailable = false;
                    m.unavailableReason = null;
                    m.consecutiveFailures = 0;
                    m.modelFailures = 0;
                    m.providerFailures = 0;
                    m.credentialFailures = 0;
                    m.endpointFailures = 0;
                    m.nextRetryAt = null;
                    saveAdminState(state);
                    renderModelCatalog();
                    window.adminRefreshModelSelect(true);
                }
            }
            
            const respEl = document.getElementById('conn-resp-model-label');
            const timeEl = document.getElementById('conn-last-success-label');
            if (respEl) respEl.innerText = testRes.resolvedModel || '-';
            if (timeEl) timeEl.innerText = new Date().toLocaleTimeString();
        } else {
            // Lifecycle: Distinguish error states and record consecutive failures. Isolate MODEL_UNAVAILABLE.
            const code = testRes.code || "FREELLM_UPSTREAM_ERROR";
            const upstreamErrorCode = testRes.upstreamErrorCode || "";
            let reason = "PROVIDER_DEGRADED";
            
            if (code === "FREELLM_REQUEST_ERROR") {
                reason = "REQUEST_INVALID";
            } else if (code === "FREELLM_ENDPOINT_ERROR") {
                reason = "ENDPOINT_MISCONFIGURED";
            } else if (code === "FREELLM_AUTH_ERROR") {
                reason = "CREDENTIAL_INVALID";
            }

            // Check for explicit model_not_found code from the proxy
            if (upstreamErrorCode === "model_not_found") {
                reason = "MODEL_UNAVAILABLE";
            }

            if (state.activeModelKey) {
                const modelIdx = state.aiModels.findIndex(m => m.key === state.activeModelKey);
                if (modelIdx !== -1) {
                    const m = state.aiModels[modelIdx];
                    m.unavailableReason = reason;
                    m.consecutiveFailures = (m.consecutiveFailures || 0) + 1;
                    
                    // Separated Failure Counters for granular diagnostics
                    if (reason === "MODEL_UNAVAILABLE") m.modelFailures = (m.modelFailures || 0) + 1;
                    if (reason === "PROVIDER_DEGRADED") m.providerFailures = (m.providerFailures || 0) + 1;
                    if (reason === "CREDENTIAL_INVALID") m.credentialFailures = (m.credentialFailures || 0) + 1;
                    if (reason === "ENDPOINT_MISCONFIGURED") m.endpointFailures = (m.endpointFailures || 0) + 1;
                    
                    // Requirement: Only mark model.unavailable as true when explicit MODEL_UNAVAILABLE is diagnosed.
                    if (reason === "MODEL_UNAVAILABLE") {
                        m.unavailable = true;
                    } else {
                        // For other statuses (e.g. ENDPOINT_MISCONFIGURED, CREDENTIAL_INVALID, PROVIDER_DEGRADED), preserve model.unavailable.
                    }
                    
                    // Next retry interval: exponential backoff + jitter (min 2s, max 5m)
                    const backoffMs = Math.min(Math.pow(2, m.consecutiveFailures) * 1000, 300 * 1000);
                    const jitter = Math.random() * 1000;
                    m.nextRetryAt = new Date(Date.now() + backoffMs + jitter).toISOString();
                    
                    saveAdminState(state);
                    renderModelCatalog();
                    window.adminRefreshModelSelect(true);
                }
            }
            throw { 
                message: testRes.message, 
                code, 
                requestId: testRes.requestId,
                requestedModel: testRes.requestedModel || execConfig.requestedModel
            };
        }
    } catch (error) {
        if (statusEl) statusEl.innerText = '연결 실패';
        if (alertEl) {
            alertEl.className = 'p-4 rounded-xl text-xs font-bold bg-rose-50 text-rose-700';
            
            let hint = "연결 실패: ";
            const code = error.code || "";
            const msg = error.message || "";
            const reqId = error.requestId || "";
            
            if (code === "FREELLM_AUTH_ERROR" || msg.includes("401") || msg.includes("Unauthorized") || msg.includes("Key")) {
                hint += "API Key 인증 오류입니다. 올바른 키 값을 입력하고 저장했는지 확인하십시오.";
            } else if (code === "FREELLM_REQUEST_ERROR") {
                hint += "요청/모델 오류: 지원되지 않는 모델이거나 잘못된 모델 코드입니다.";
            } else if (code === "FREELLM_ENDPOINT_ERROR") {
                hint += "엔드포인트 오류: API 주소가 정확하지 않습니다.";
            } else if (code === "FREELLM_RATE_LIMIT_ERROR") {
                hint += "사용량 제한: API 할당량을 초과하였거나 사용량 제한 상태입니다.";
            } else if (code === "FREELLM_SERVER_ERROR" || code === "FREELLM_UPSTREAM_ERROR" || msg.includes("502") || msg.includes("503")) {
                hint += "Upstream 서버 장애입니다. 대상 서비스 상태를 확인하십시오.";
            } else if (code === "FREELLM_TIMEOUT_ERROR" || msg.includes("timeout") || msg.includes("504")) {
                hint += "요청 대기 제한(Timeout) 시간을 초과하였습니다.";
            } else {
                let cleanedMsg = msg;
                const state = getAdminState();
                const keys = [
                    state.freellmApiKey,
                    state.openrouterApiKey,
                    state.geminiApiKey
                ].filter(Boolean);

                keys.forEach(k => {
                    cleanedMsg = cleanedMsg.split(k).join("REDACTED_KEY");
                    cleanedMsg = cleanedMsg.split(encodeURIComponent(k)).join("REDACTED_KEY");
                    cleanedMsg = cleanedMsg.split(encodeURIComponent(encodeURIComponent(k))).join("REDACTED_KEY");
                    const escaped = JSON.stringify(k).slice(1, -1);
                    if (escaped !== k) {
                        cleanedMsg = cleanedMsg.split(escaped).join("REDACTED_KEY");
                    }
                });
                hint += cleanedMsg;
            }

            const requestedModel = error.requestedModel || diagnostics.requestedModel || 'N/A';
            hint += ` (진단 정보 - 제공자: ${diagnostics.provider || 'N/A'}, 요청모델: ${requestedModel}, 에러코드: ${code || 'UNKNOWN'})`;

            if (reqId && reqId !== 'n/a') {
                hint += ` (Request ID: ${reqId})`;
            }
            alertEl.innerText = hint;
        }
    } finally {
        setTestButtonsState(false);
    }
}

window.exitProject = function () {
    import('../core/stateManager.js').then(m => {
        m.appState.setState({ currentProjectId: null, proposalStep: 0, quickDocStep: 0 });
        window.location.reload(); // Hard reset for safety
    });
};

// ============== Prompts ==============

export function toggleAdminPrompt(key, btnElement) {
    const v = document.getElementById(`admin-view-${key}`);
    const i = document.getElementById(`admin-input-${key}`);
    if (!v || !i) return;

    if (i.classList.contains('hidden')) {
        i.value = v.dataset.raw || v.innerText;
        v.classList.add('hidden'); i.classList.remove('hidden');
        btnElement.innerText = "💾 저장";
    } else {
        const state = getAdminState();
        state.prompts[key] = i.value;
        v.dataset.raw = i.value;
        v.innerHTML = safeMarkedParse(i.value);
        v.classList.remove('hidden'); i.classList.add('hidden');
        btnElement.innerText = "✏️ 편집";
        saveAdminState(state);
    }
}

export function loadSavedPrompts() {
    try {
        const state = getAdminState() || {};
        const prompts = state.prompts || {};
        ['PROMPT_PROPOSAL_ANALYSIS', 'PROMPT_PROPOSAL_TOC', 'PROMPT_PROPOSAL_SLIDE', 'PROMPT_QUICKDOC_GEN'].forEach(key => {
            const val = prompts[key] || "";
            const v = document.getElementById(`admin-view-${key}`);
            const i = document.getElementById(`admin-input-${key}`);
            if (v) { v.dataset.raw = val; v.innerHTML = safeMarkedParse(val); }
            if (i) i.value = val;
        });
    } catch (e) {
        console.error("[loadSavedPrompts] Failed to load prompts safely:", e);
    }
}

window.adminResetPrompts = function () {
    if (!confirm("모든 프롬프트를 시스템 기본값으로 초기화하시겠습니까?")) return;
    const state = getAdminState();
    state.prompts = JSON.parse(JSON.stringify(defaultState.prompts));
    saveAdminState(state);
    loadSavedPrompts();
    alert("프롬프트가 초기화되었습니다.");
};

// ============== AI Call Logs ==============

function renderAiLogs() {
    const tbody = document.getElementById('ai-logs-tbody');
    if (!tbody) return;

    let logs = [];
    try {
        logs = JSON.parse(localStorage.getItem('auraDoc_aiLogs') || '[]');
    } catch (e) {
        console.error("Failed to parse logs:", e);
    }

    if (logs.length === 0) {
        tbody.innerHTML = '<tr><td colspan="6" class="text-center py-10 text-slate-400 font-medium">기록된 로그가 없습니다.</td></tr>';
        return;
    }

    // Apply Filters
    const search = document.getElementById('log-search')?.value.toLowerCase() || '';
    const statusFilter = document.getElementById('log-filter-status')?.value || 'all';
    const providerFilter = document.getElementById('log-filter-provider')?.value || 'all';

    const filtered = logs.filter(log => {
        const matchesSearch = !search || 
            (log.labelId && log.labelId.toLowerCase().includes(search)) ||
            (log.prompt && log.prompt.toLowerCase().includes(search)) ||
            (log.error && log.error.toLowerCase().includes(search));
        
        const status = log.status || 'SUCCESS';
        const matchesStatus = statusFilter === 'all' || status === statusFilter;
        const matchesProvider = providerFilter === 'all' || log.provider === providerFilter;

        return matchesSearch && matchesStatus && matchesProvider;
    }).reverse(); // Newest first

    if (filtered.length === 0) {
        tbody.innerHTML = '<tr><td colspan="6" class="text-center py-10 text-slate-400 font-medium">필터 조건에 맞는 로그가 없습니다.</td></tr>';
        return;
    }

    tbody.innerHTML = filtered.map((log, idx) => {
        const status = log.status || 'SUCCESS';
        const statusClass = status === 'SUCCESS' ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700';
        const statusIcon = status === 'SUCCESS' ? '✅' : '❌';

        return `
            <tr class="group border-b border-gray-50 hover:bg-slate-50 transition">
                <td class="px-4 py-3 text-xs font-mono text-slate-400">${log.timestamp || 'N/A'}</td>
                <td class="px-4 py-3 font-bold text-slate-700 text-sm">${log.labelId || 'unnamed'}</td>
                <td class="px-4 py-3 text-xs font-bold text-slate-500 uppercase">${log.provider}</td>
                <td class="px-4 py-3 text-[11px] font-mono text-slate-400">${log.model || '-'}</td>
                <td class="px-4 py-3 text-center">
                    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-black ${statusClass}">
                        ${statusIcon} ${status}
                    </span>
                </td>
                <td class="px-4 py-3 text-center text-[11px] font-bold text-slate-500">
                    ${log.duration || '-'}
                </td>
                <td class="px-4 py-3">
                    <div class="flex items-center justify-between gap-4">
                        <p class="text-xs text-slate-500 truncate max-w-[300px]">${(log.prompt || '').substring(0, 100)}...</p>
                        <button onclick="window.adminShowLogDetail(${logs.length - 1 - idx})" class="text-[10px] font-bold text-indigo-600 hover:underline shrink-0">상세보기</button>
                    </div>
                </td>
            </tr>
        `;
    }).join('');
}

window.adminFilterLogs = function() {
    renderAiLogs();
};

window.adminClearLogs = function() {
    if (!confirm("모든 AI 호출 로그를 영구적으로 삭제하시겠습니까?")) return;
    localStorage.removeItem('auraDoc_aiLogs');
    renderAiLogs();
};

window.adminShowLogDetail = function(originalIdx) {
    const logs = JSON.parse(localStorage.getItem('auraDoc_aiLogs') || '[]');
    const log = logs[originalIdx];
    if (!log) return;

    const detailHtml = `
        <div class="space-y-4 text-left max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
            <div class="grid grid-cols-2 gap-4 bg-slate-50 p-4 rounded-xl border border-slate-100">
                <div><p class="text-[10px] font-bold text-slate-400 uppercase mb-1">Timestamp</p><p class="text-sm font-bold text-slate-800">${log.timestamp}</p></div>
                <div><p class="text-[10px] font-bold text-slate-400 uppercase mb-1">Status</p><p class="text-sm font-bold ${log.status === 'FAILURE' ? 'text-rose-600' : 'text-emerald-600'}">${log.status || 'SUCCESS'}</p></div>
                <div><p class="text-[10px] font-bold text-slate-400 uppercase mb-1">Provider/Model</p><p class="text-sm font-bold text-slate-800">${log.provider} / ${log.model}</p></div>
                <div><p class="text-[10px] font-bold text-slate-400 uppercase mb-1">Label ID</p><p class="text-sm font-bold text-indigo-600">${log.labelId}</p></div>
                <div><p class="text-[10px] font-bold text-slate-400 uppercase mb-1">Duration</p><p class="text-sm font-bold text-slate-800">${log.duration || '-'}</p></div>
            </div>
            
            ${log.error ? `
            <div class="p-4 bg-rose-50 border border-rose-100 rounded-xl">
                <p class="text-[10px] font-bold text-rose-400 uppercase mb-1">Error Message</p>
                <p class="text-xs font-mono text-rose-700 whitespace-pre-wrap">${log.error}</p>
            </div>
            ` : ''}

            <div>
                <p class="text-[10px] font-bold text-slate-400 uppercase mb-2">System Instruction</p>
                <div class="p-4 bg-slate-900 rounded-xl text-[11px] font-mono text-slate-300 whitespace-pre-wrap border border-slate-700">${log.system || 'None'}</div>
            </div>

            <div>
                <p class="text-[10px] font-bold text-slate-400 uppercase mb-2">User Prompt</p>
                <div class="p-4 bg-slate-900 rounded-xl text-[11px] font-mono text-indigo-300 whitespace-pre-wrap border border-slate-700">${log.prompt}</div>
            </div>
        </div>
    `;

    // Re-using a simple modal or alert-like container for detail
    const modal = document.createElement('div');
    modal.className = "fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-[300] flex items-center justify-center p-4 fade-in";
    modal.innerHTML = `
        <div class="bg-white rounded-[24px] shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col scale-in">
            <div class="px-8 py-5 border-b border-gray-100 flex justify-between items-center bg-slate-50">
                <h4 class="text-lg font-extrabold text-slate-800">Log Details: ${log.labelId}</h4>
                <button onclick="this.closest('.fixed').remove()" class="text-3xl text-slate-300 hover:text-rose-500 transition">&times;</button>
            </div>
            <div class="p-8">
                ${detailHtml}
            </div>
            <div class="px-8 py-4 bg-slate-50 border-t border-gray-100 flex justify-end">
                <button onclick="this.closest('.fixed').remove()" class="px-6 py-2 bg-slate-800 text-white font-bold rounded-xl shadow-lg hover:bg-slate-900 transition">닫기</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
};

// ============== Initialization ==============

export function setSystemStatus(status) {
    const badge = document.getElementById('sync-status');
    if (!badge) return;
    switch (status) {
        case 'ready': badge.innerText = "Ready"; badge.className = "bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-[11px] font-bold"; break;
        case 'busy': badge.innerText = "Processing..."; badge.className = "bg-amber-100 text-amber-700 px-3 py-1 rounded-full text-[11px] font-bold animate-pulse"; break;
        case 'error': badge.innerText = "API Error"; badge.className = "bg-rose-100 text-rose-700 px-3 py-1 rounded-full text-[11px] font-bold"; break;
    }
}

export function initAdminUI() {
    if (window.adminUIListenersBound) return;
    window.adminUIListenersBound = true;

    window.toggleAdminPrompt = toggleAdminPrompt;

    // 1. Click event delegation on document
    document.addEventListener('click', (e) => {
        const target = e.target;

        // A. Sidebar & Modals
        if (target.closest('#btn-open-admin')) {
            openAdminModal();
            return;
        }
        if (target.closest('#btn-close-admin') || target.closest('#btn-settings-back') || target.closest('#btn-settings-close-sidebar')) {
            closeAdminModal();
            return;
        }
        if (target.closest('#btn-open-settings')) {
            openAdminModal();
            switchAdminTab('view-documentTypes');
            return;
        }

        // B. Tabs Switching (.admin-tab)
        const tab = target.closest('.admin-tab');
        if (tab) {
            switchAdminTab(tab.dataset.target, tab);
            return;
        }

        // C. Sourcing Config / manual actions
        if (target.closest('#btn-save-sourcing-config')) {
            saveSourcingConfig();
            return;
        }
        if (target.closest('#btn-refresh-history')) {
            loadSourcingHistory();
            return;
        }
        if (target.closest('#btn-manual-fetch')) {
            triggerManualFetch();
            return;
        }
        if (target.closest('#btn-test-transcript-health')) {
            refreshTranscriptHealth();
            return;
        }

        // D. Toggle prompts (.btn-toggle-prompt)
        const togglePromptBtn = target.closest('.btn-toggle-prompt');
        if (togglePromptBtn) {
            toggleAdminPrompt(togglePromptBtn.dataset.key, togglePromptBtn);
            return;
        }

        // E. Template editor tabs (.tpl-tab)
        const tplTab = target.closest('.tpl-tab');
        if (tplTab) {
            document.querySelectorAll('.tpl-tab').forEach(t => t.classList.remove('active', 'border-indigo-50', 'border-b-2', 'border-indigo-500', 'bg-white'));
            tplTab.classList.add('active', 'border-b-2', 'border-indigo-500', 'bg-white');
            const tabTarget = tplTab.dataset.tab;
            document.getElementById('tpl-editor-pane').classList.toggle('hidden', tabTarget !== 'editor');
            document.getElementById('tpl-preview-pane').classList.toggle('hidden', tabTarget !== 'preview');
            if (tabTarget === 'preview') window.adminUpdateTemplatePreview();
            return;
        }
    });

    // 2. Change event delegation on document
    document.addEventListener('change', (e) => {
        const target = e.target;
        if (target && target.id === 'admin-ai-provider') {
            window.adminRefreshModelSelect();
        }
    });

    document.getElementById('schedule-days-container')?.addEventListener('click', (e) => {
        const btn = e.target.closest('.day-btn');
        if (btn) {
            const isActive = btn.classList.contains('bg-indigo-50');
            if (isActive) {
                btn.className = "day-btn w-10 h-10 rounded-xl border border-slate-200 bg-white text-slate-400 font-bold text-xs";
            } else {
                btn.className = "day-btn w-10 h-10 rounded-xl border-2 border-indigo-600 bg-indigo-50 text-indigo-600 font-bold text-xs";
            }
        }
    });

    const timesContainer = document.getElementById('schedule-times-container');
    if (timesContainer) {
        timesContainer.addEventListener('click', (e) => {
            if (e.target.closest('.btn-remove-time')) {
                e.target.closest('.schedule-time-item').remove();
            } else if (e.target.closest('#btn-add-schedule-time')) {
                const t = prompt("추가할 시간을 입력하세요 (예: 09:00)");
                if (t && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(t.trim())) {
                    const timeDiv = document.createElement('div');
                    timeDiv.className = 'schedule-time-item px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-700 flex items-center gap-2';
                    timeDiv.innerHTML = `${t.trim()} <button class="btn-remove-time text-slate-300 hover:text-rose-500">&times;</button>`;
                    timesContainer.insertBefore(timeDiv, document.getElementById('btn-add-schedule-time'));
                } else if (t) {
                    alert("올바른 시간 형식이 아닙니다. (HH:MM)");
                }
            }
        });
    }

    // 3. Input formatting delegation
    document.addEventListener('input', (e) => {
        const target = e.target;
        if (target && target.id === 'config-min-budget') {
            let value = target.value.replace(/,/g, '');
            if (!isNaN(value) && value !== '') {
                target.value = Number(value).toLocaleString();
            } else {
                target.value = value.replace(/[^0-9]/g, '');
            }
        }
    });

    loadSavedPrompts();

    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get('mode') || 'admin';
    
    const groupSettings = document.getElementById('sidebar-group-settings');
    const groupAdmin = document.getElementById('sidebar-group-admin');
    
    if (groupAdmin) groupAdmin.classList.remove('hidden');
    if (groupSettings) groupSettings.classList.remove('hidden');
    
    let defaultTab = 'view-aiSettings';
    if (mode === 'settings') {
        defaultTab = 'view-naverBlogConfig';
    } else {
        defaultTab = 'view-aiSettings';
    }
    
    const tabTarget = urlParams.get('tab') || defaultTab;
    if (tabTarget) {
        const targetBtn = document.querySelector(`.admin-tab[data-target="${tabTarget}"]`);
        if (targetBtn) {
            switchAdminTab(tabTarget, targetBtn);
        } else {
            switchAdminTab(tabTarget);
        }
    }

    if (tabTarget === 'view-aiSettings') {
        refreshTranscriptHealth();
    }

    window.admin = { setSystemStatus };
    
    // Globalize sourcing functions for direct HTML calls
    window.adminAddScheduleTime = adminAddScheduleTime;
    window.adminImportExcel = adminImportExcel;
    window.adminHandleExcelImport = adminHandleExcelImport;
}

// Sourcing Helper Functions
async function loadSourcingConfig() {
    try {
        const { sourcingService } = await import('../services/sourcingService.js');
        const config = await sourcingService.getConfig() || {};
        
        const includeInput = document.getElementById('config-include-kw');
        const excludeInput = document.getElementById('config-exclude-kw');
        const excludeMethodsInput = document.getElementById('config-exclude-methods');
        const excludeIndustriesInput = document.getElementById('config-exclude-industries');
        const excludeCategoriesInput = document.getElementById('config-exclude-categories');
        const demandOrgInput = document.getElementById('config-demand-org');
        const budgetInput = document.getElementById('config-min-budget');
        const periodSelect = document.getElementById('config-period');
        const emailNotify = document.getElementById('config-notify-email');
        const kakaoNotify = document.getElementById('config-notify-kakao');
        const telegramNotify = document.getElementById('config-notify-telegram');
        const discordNotify = document.getElementById('config-notify-discord');
        const telegramToken = document.getElementById('config-telegram-token');
        const telegramChatId = document.getElementById('config-telegram-chatid');
        const discordWebhook = document.getElementById('config-discord-webhook');
        const typeError = document.getElementById('config-type-error');
        const typeSourcing = document.getElementById('config-type-sourcing');
        const typeTask = document.getElementById('config-type-task');
        const recipients = document.getElementById('config-recipients');
        const scheduleEnabled = document.getElementById('config-schedule-enabled');

        if (includeInput) includeInput.value = config.includeKw?.join(', ') || '';
        if (excludeInput) excludeInput.value = config.excludeKw?.join(', ') || '';
        if (excludeMethodsInput) excludeMethodsInput.value = config.excludeMethods?.join(', ') || '';
        if (excludeIndustriesInput) excludeIndustriesInput.value = config.excludeIndustries?.join(', ') || '';
        if (excludeCategoriesInput) excludeCategoriesInput.value = config.excludeCategories?.join(', ') || '';
        if (demandOrgInput) demandOrgInput.value = config.demandOrg || '';
        
        if (budgetInput) budgetInput.value = config.minBudget ? Number(config.minBudget).toLocaleString() : '';
        if (periodSelect) periodSelect.value = config.period || 'yesterday-2d';
        if (emailNotify) emailNotify.checked = config.notifications?.email || false;
        if (kakaoNotify) kakaoNotify.checked = config.notifications?.kakao || false;
        if (telegramNotify) telegramNotify.checked = config.notifications?.telegram || false;
        if (discordNotify) discordNotify.checked = config.notifications?.discord || false;
        if (telegramToken) telegramToken.value = config.telegramToken || '';
        if (telegramChatId) telegramChatId.value = config.telegramChatId || '';
        if (discordWebhook) discordWebhook.value = config.discordWebhook || '';
        
        if (typeError) typeError.checked = config.alertTypes?.error !== false;
        if (typeSourcing) typeSourcing.checked = config.alertTypes?.sourcing !== false;
        if (typeTask) typeTask.checked = config.alertTypes?.task !== false;

        if (recipients) recipients.value = config.recipients || '';
        if (scheduleEnabled) scheduleEnabled.checked = config.schedule?.enabled || false;

        // Load schedule times
        const timesContainer = document.getElementById('schedule-times-container');
        if (timesContainer) {
            const times = config.schedule?.times || ['10:00', '17:00'];
            timesContainer.innerHTML = '';
            times.forEach(t => {
                const timeDiv = document.createElement('div');
                timeDiv.className = 'schedule-time-item px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-700 flex items-center gap-2';
                timeDiv.innerHTML = `${t} <button class="btn-remove-time text-slate-300 hover:text-rose-500">&times;</button>`;
                timesContainer.appendChild(timeDiv);
            });
        }

        // Load schedule days
        const dayBtns = document.querySelectorAll('.day-btn');
        const activeDays = config.schedule?.days || [1,2,3,4,5];
        dayBtns.forEach(btn => {
            const dayVal = Number(btn.dataset.day);
            if (activeDays.includes(dayVal)) {
                btn.className = "day-btn w-10 h-10 rounded-xl border-2 border-indigo-600 bg-indigo-50 text-indigo-600 font-bold text-xs";
            } else {
                btn.className = "day-btn w-10 h-10 rounded-xl border border-slate-200 bg-white text-slate-400 font-bold text-xs";
            }
        });
    } catch (err) {
        console.error("[loadSourcingConfig] Failed to load sourcing config:", err);
    }
}

async function saveSourcingConfig() {
    try {
        const { sourcingService } = await import('../services/sourcingService.js');
        
        // Get existing config to merge missing DOM values
        const existing = await sourcingService.getConfig() || {};
        
        // Extract active days
        const activeDays = [];
        document.querySelectorAll('.day-btn').forEach(btn => {
            if (btn.classList.contains('bg-indigo-50')) {
                activeDays.push(Number(btn.dataset.day));
            }
        });

        // Extract active times
        const activeTimes = [];
        document.querySelectorAll('.schedule-time-item').forEach(div => {
            const t = div.innerText.replace('×', '').trim();
            if (t) activeTimes.push(t);
        });

        const emailChecked = document.getElementById('config-notify-email')?.checked;
        const recipientsStr = document.getElementById('config-recipients')?.value || '';

        if (emailChecked && !recipientsStr.trim()) {
            alert("이메일 알림을 선택하신 경우, 수신할 이메일 주소를 반드시 입력해 주세요.");
            return;
        }

        const includeEl = document.getElementById('config-include-kw');
        const excludeEl = document.getElementById('config-exclude-kw');
        const excludeMethodsEl = document.getElementById('config-exclude-methods');
        const excludeIndustriesEl = document.getElementById('config-exclude-industries');
        const excludeCategoriesEl = document.getElementById('config-exclude-categories');
        const demandOrgEl = document.getElementById('config-demand-org');
        const budgetEl = document.getElementById('config-min-budget');
        const periodEl = document.getElementById('config-period');
        const notifyKakaoEl = document.getElementById('config-notify-kakao');
        const notifyTelegramEl = document.getElementById('config-notify-telegram');
        const notifyDiscordEl = document.getElementById('config-notify-discord');
        const telegramTokenEl = document.getElementById('config-telegram-token');
        const telegramChatIdEl = document.getElementById('config-telegram-chatid');
        const discordWebhookEl = document.getElementById('config-discord-webhook');
        const typeErrorEl = document.getElementById('config-type-error');
        const typeSourcingEl = document.getElementById('config-type-sourcing');
        const typeTaskEl = document.getElementById('config-type-task');
        const scheduleEnabledEl = document.getElementById('config-schedule-enabled');

        const config = {
            includeKw: includeEl ? includeEl.value.split(',').map(s => s.trim()).filter(Boolean) : (existing.includeKw || []),
            excludeKw: excludeEl ? excludeEl.value.split(',').map(s => s.trim()).filter(Boolean) : (existing.excludeKw || []),
            excludeMethods: excludeMethodsEl ? excludeMethodsEl.value.split(',').map(s => s.trim()).filter(Boolean) : (existing.excludeMethods || []),
            excludeIndustries: excludeIndustriesEl ? excludeIndustriesEl.value.split(',').map(s => s.trim()).filter(Boolean) : (existing.excludeIndustries || []),
            excludeCategories: excludeCategoriesEl ? excludeCategoriesEl.value.split(',').map(s => s.trim()).filter(Boolean) : (existing.excludeCategories || []),
            demandOrg: demandOrgEl ? demandOrgEl.value.trim() : (existing.demandOrg || ''),
            minBudget: budgetEl ? Number(budgetEl.value.replace(/,/g, '')) : (existing.minBudget || 0),
            period: periodEl ? periodEl.value : (existing.period || 'yesterday-2d'),
            telegramToken: telegramTokenEl ? telegramTokenEl.value.trim() : (existing.telegramToken || ''),
            telegramChatId: telegramChatIdEl ? telegramChatIdEl.value.trim() : (existing.telegramChatId || ''),
            discordWebhook: discordWebhookEl ? discordWebhookEl.value.trim() : (existing.discordWebhook || ''),
            notifications: {
                email: emailChecked !== undefined ? emailChecked : (existing.notifications?.email || false),
                kakao: notifyKakaoEl ? notifyKakaoEl.checked : (existing.notifications?.kakao || false),
                telegram: notifyTelegramEl ? notifyTelegramEl.checked : (existing.notifications?.telegram || false),
                discord: notifyDiscordEl ? notifyDiscordEl.checked : (existing.notifications?.discord || false)
            },
            alertTypes: {
                error: typeErrorEl ? typeErrorEl.checked : (existing.alertTypes?.error !== false),
                sourcing: typeSourcingEl ? typeSourcingEl.checked : (existing.alertTypes?.sourcing !== false),
                task: typeTaskEl ? typeTaskEl.checked : (existing.alertTypes?.task !== false)
            },
            recipients: recipientsStr || (existing.recipients || ''),
            schedule: {
                enabled: scheduleEnabledEl ? scheduleEnabledEl.checked : (existing.schedule?.enabled || false),
                times: activeTimes.length ? activeTimes : (existing.schedule?.times || []),
                days: activeDays.length ? activeDays : (existing.schedule?.days || [])
            }
        };
        
        await sourcingService.saveConfig(config);
        alert("소싱 설정이 저장되었습니다.");
    } catch (err) {
        console.error("[saveSourcingConfig] Failed to save config:", err);
        alert("저장 실패: " + err.message);
    }
}


async function startProposalFromAdmin(title) {
    if (!confirm(`'${title}' 공고를 기반으로 새로운 제안 프로젝트를 시작하시겠습니까?`)) return;
    
    // Redirect to index.html with parameters since this is a separate page
    const params = new URLSearchParams();
    params.set('action', 'new-proposal');
    params.set('title', title);
    
    window.location.href = `index.html?${params.toString()}`;
}

async function startProposalFromAdminByID(id) {
    try {
        const { sourcingService } = await import('../services/sourcingService.js');
        const history = await sourcingService.getSavedAnnouncements();
        const found = history.find(ann => String(ann.id) === String(id));
        if (found) {
            startProposalFromAdmin(found.title);
        } else {
            // Local mode fallback
            const localHistory = JSON.parse(localStorage.getItem('auraDoc_localAnnouncements') || '[]');
            const localFound = localHistory.find(ann => String(ann.id) === String(id));
            if (localFound) {
                startProposalFromAdmin(localFound.title);
            } else {
                alert("해당 공고를 찾을 수 없습니다.");
            }
        }
    } catch(e) {
        console.error("startProposalFromAdminByID failed:", e);
    }
}
window.startProposalFromAdminByID = startProposalFromAdminByID;

async function syncInitialSourcingData() {
    if (!confirm("Excel에서 추출된 초기 데이터를 DB에 반영하시겠습니까? (기존 데이터는 유지됩니다)")) return;
    
    const { sourcingService } = await import('../services/sourcingService.js');
    const success = await sourcingService.initDatabase();
    
    if (success) {
        alert("초기 데이터가 성공적으로 DB에 반영되었습니다.");
        loadSourcingHistory();
    } else {
        alert("데이터 반영 중 오류가 발생했습니다. 콘솔 로그를 확인하세요.");
    }
}

async function triggerManualFetch() {
    const { sourcingService } = await import('../services/sourcingService.js');
    const btn = document.getElementById('btn-manual-fetch');
    const originalText = btn ? btn.innerHTML : '⚡ 실시간 공고 수동 가져오기';
    
    if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span>데이터 요청 중...</span>';
    }
    
    // Status states
    let finalStatus = 'SUCCESS_WITH_ITEMS';
    let errorMessage = '';
    let results = [];
    let totalFetched = 0;
    
    try {
        // Ensure local DB seed is ready first
        let localData = await sourcingService.getSavedAnnouncements();
        if (localData.length === 0) {
            await sourcingService.initDatabase();
        }
        
        const config = await sourcingService.getConfig();
        let isLocalFallback = false;
        
        try {
            results = await sourcingService.fetchFromNara(config);
            totalFetched = sourcingService.lastFetchTotalCount || 0;
            
            if (results.length > 0) {
                finalStatus = 'SUCCESS_WITH_ITEMS';
            } else {
                finalStatus = 'SUCCESS_EMPTY';
            }
        } catch (fetchErr) {
            console.warn("OpenAPI real-time fetch failed, analyzing error and checking fallback:", fetchErr);
            const msg = (fetchErr.message || '').toLowerCase();
            
            if (msg.includes('timeout') || msg.includes('504')) {
                finalStatus = 'UPSTREAM_TIMEOUT';
            } else if (msg.includes('auth') || msg.includes('401') || msg.includes('key') || msg.includes('unauthorized')) {
                finalStatus = 'AUTH_ERROR';
            } else if (msg.includes('rate') || msg.includes('429') || msg.includes('limit')) {
                finalStatus = 'RATE_LIMITED';
            } else if (msg.includes('502') || msg.includes('503') || msg.includes('upstream') || msg.includes('server')) {
                finalStatus = 'UPSTREAM_ERROR';
            } else {
                finalStatus = 'UPSTREAM_ERROR';
            }
            errorMessage = fetchErr.message || 'Unknown upstream fetch failure';
            isLocalFallback = true;
        }

        // Fallback execution if real-time OpenAPI call has failed
        if (isLocalFallback) {
            const seeded = await sourcingService.getSavedAnnouncements();
            results = seeded.filter(item => {
                const title = item.title || '';
                const hasInclude = config.includeKw.length === 0 || config.includeKw.some(kw => title.includes(kw));
                const hasExclude = config.excludeKw.some(kw => title.includes(kw));
                return hasInclude && !hasExclude;
            });
            totalFetched = seeded.length;

            if (results.length > 0) {
                finalStatus = 'FALLBACK_USED';
            } else {
                finalStatus = 'FALLBACK_EMPTY';
            }
        }

        // Save announcements if we actually obtained data (from OpenAPI or local fallback)
        if (results.length > 0) {
            await sourcingService.saveAnnouncements(results);
        }
        await loadSourcingHistory();

        // 1 Single alert based on consolidated status state
        switch (finalStatus) {
            case 'SUCCESS_WITH_ITEMS':
                alert(`✅ 수집 성공: 조달청 OpenAPI 수신 공고 총 ${totalFetched}건 중, 필터링 규칙을 통과한 신규 공고 ${results.length}건이 DB에 저장되었습니다.`);
                break;
            case 'SUCCESS_EMPTY':
                alert(`ℹ️ 수집 완료 (신규 없음): 조달청 OpenAPI 수신 결과, 필터링 규칙을 통과한 새로운 공고가 존재하지 않아 신규 저장 건수가 0건입니다.`);
                break;
            case 'UPSTREAM_TIMEOUT':
                alert(`❌ 수집 실패 (시간 초과): 조달청 API 호출 시간이 초과되었습니다. 네트워크 상태를 확인하거나 잠시 후 다시 시도하십시오.`);
                break;
            case 'AUTH_ERROR':
                alert(`❌ 수집 실패 (인증 오류): 조달청 OpenAPI 인증 토큰 정보가 유효하지 않습니다. 관리자 권한 및 API Key 설정을 확인하십시오.`);
                break;
            case 'RATE_LIMITED':
                alert(`❌ 수집 실패 (사용량 초과): 조달청 API 호출 한도(Rate Limit)를 초과하였습니다. 잠시 후 다시 시도하십시오.`);
                break;
            case 'UPSTREAM_ERROR':
                alert(`❌ 수집 실패 (서버 장애): 조달청 OpenAPI 업스트림 서버 장애가 발생했습니다. (상세: ${errorMessage})`);
                break;
            case 'FALLBACK_USED':
                alert(`⚠️ 로컬 보조 모드 작동: 조달청 OpenAPI 응답 지연으로 로컬 Seeding 데이터셋 중 필터링 규칙을 통과한 신규 공고 ${results.length}건이 로컬 데이터베이스에 저장되었습니다.`);
                break;
            case 'FALLBACK_EMPTY':
                alert(`⚠️ 로컬 보조 모드 실패: 조달청 API 응답 지연으로 실제 공고를 가져오지 못했습니다. 대체 데이터도 없어 저장된 신규 공고가 없습니다.`);
                break;
        }

    } catch (e) {
        alert("❌ 시스템 처리 실패: " + e.message);
    } finally {
        if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalText;
        }
    }
}

// Sourcing Helper Functions
async function adminAddScheduleTime() {
    const input = document.getElementById('input-new-schedule-time');
    const timesContainer = document.getElementById('schedule-times-container');
    if (!input || !timesContainer) return;
    
    const t = input.value.trim();

    if (t && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(t)) {
        const timeDiv = document.createElement('div');
        timeDiv.className = 'schedule-time-item px-3 py-1.5 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-700 flex items-center gap-2';
        timeDiv.innerHTML = `${t} <button class="btn-remove-time text-slate-300 hover:text-rose-500" onclick="this.closest('.schedule-time-item').remove()">&times;</button>`;
        timesContainer.appendChild(timeDiv);
        input.value = '';
    } else if (t !== '') {
        alert("올바른 시간 형식이 아닙니다. (HH:MM)");
    }
}

function adminImportExcel() {
    document.getElementById('input-excel-import')?.click();
}

async function adminHandleExcelImport(input) {
    if (!input.files || !input.files[0]) return;
    
    const file = input.files[0];
    const reader = new FileReader();
    
    reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
            alert("엑셀 데이터가 비어있습니다.");
            return;
        }

        const { sourcingService } = await import('../services/sourcingService.js');
        const announcements = jsonData.map(row => {
            const id = String(row['공고번호'] || row['ID'] || row['bidNtceNo'] || Math.random().toString(36).substr(2, 9));
            const ord = String(row['입찰공고차수'] || '00');
            const fullId = id.includes('-') ? id : `${id}-${ord}`;
            
            const budgetVal = Number(String(row['추정금액'] || row['추정가격'] || row['가격'] || row['presmptPrce'] || 0).replace(/[^0-9.]/g, ''));
            
            const bidNoOnly = id.split('-')[0];
            const bidOrdOnly = ord;
            const directUrl = `https://www.g2b.go.kr:8081/ep/invitation/publish/bidInfoDtl.do?bidNo=${bidNoOnly}&bidOrd=${bidOrdOnly}`;

            return {
                id: fullId,
                title: row['공고명'] || row['제목'] || row['bidNtceNm'] || '무제 공고',
                org: row['수요 기관'] || row['수요기관'] || row['기관'] || row['dminsttNm'] || '알 수 없음',
                budget: budgetVal,
                date: row['공고일'] || row['공고일시'] || row['bidNtceDt'] || new Date().toISOString().split('T')[0],
                deadline: row['입찰 종료'] || row['입찰종료일시'] || row['bidClseDt'] || row['마감일시'] || '-',
                status: 'imported',
                
                partcptBgn: row['입찰 참가자격등록 시작'] || '',
                partcptEnd: row['입찰 참가자격등록 종료'] || '',
                docBgn: row['제안서 제출시작'] || '',
                docEnd: row['제안서 제출종료'] || '',
                bidBgn: row['입찰 시작'] || '',
                bidEnd: row['입찰 종료'] || '',
                evalDate: row['제안 평가'] || '',
                openDate: row['개찰'] || '',
                managerNm: row['공고기관담당자명'] || '',
                managerTel: row['공고기관담당자전화번호'] || '',
                managerEmail: row['공고기관담당자이메일주소'] || '',
                dcmtgDt: row['설명회실시일시'] || '',
                dcmtgPlce: row['설명회실시장소'] || '',
                limitYn: row['업종제한'] || 'N',
                summary: row['요약'] || '',
                source: row['출처'] || '나라장터',
                url: directUrl,
                raw: row
            };
        });

        await sourcingService.saveAnnouncements(announcements);
        alert(`${announcements.length}개의 모든 레코드가 성공적으로 임포트되었습니다.`);
        loadSourcingHistory();
        input.value = '';
    };
    
    reader.readAsArrayBuffer(file);
}

async function showSourcingDetail(id) {
    const { sourcingService } = await import('../services/sourcingService.js');
    const history = await sourcingService.getSavedAnnouncements();
    const ann = history.find(a => a.id === id);
    if (!ann) return;

    const raw = ann.raw || ann;
    
    const budgetVal = Number(ann.budget || raw.presmptPrce || raw.assignBdgtAmt || 0);
    const formattedBudget = new Intl.NumberFormat('ko-KR').format(budgetVal);
    
    const bidNo = ann.id || '--';
    const demandOrg = ann.org || '알 수 없음';
    const regDate = ann.date || '--';
    const closeDate = ann.deadline || '--';
    
    const partcptTrm = (ann.partcptBgn || ann.partcptEnd) ? `${ann.partcptBgn || '--'} ~ ${ann.partcptEnd || '--'}` : '--';
    const docTrm = (ann.docBgn || ann.docEnd) ? `${ann.docBgn || '--'} ~ ${ann.docEnd || '--'}` : '--';
    const bidTrm = (ann.bidBgn || ann.bidEnd) ? `${ann.bidBgn || '--'} ~ ${ann.bidEnd || '--'}` : '--';
    const evalTrm = ann.evalDate || '--';
    const openTrm = ann.openDate || '--';

    const managerInfo = (ann.managerNm || ann.managerTel) ? `${ann.managerNm || '담당자'} (${ann.managerTel || '--'})` : '--';
    const dcmtgInfo = (ann.dcmtgDt || ann.dcmtgPlce) ? `${ann.dcmtgDt || '--'} / 장소: ${ann.dcmtgPlce || '--'}` : '--';
    const limitInfo = ann.limitYn || '확인 필요';

    // Parse bidNo and bidOrd to construct direct URL fallback
    const rawNo = ann.id ? ann.id.split('-')[0] : '';
    const rawOrd = ann.id ? (ann.id.split('-')[1] || '00') : '00';
    const finalUrl = ann.url && ann.url !== '#' 
        ? ann.url 
        : `https://www.g2b.go.kr:8081/ep/invitation/publish/bidInfoDtl.do?bidNo=${rawNo}&bidOrd=${rawOrd}`;

    // Extract attachments
    let filesHtml = '';
    for (let i = 1; i <= 10; i++) {
        const fileUrl = raw[`ntceSpecDocUrl${i}`];
        const fileName = raw[`ntceSpecFileNm${i}`];
        if (fileUrl && fileName) {
            filesHtml += `
                <a href="${fileUrl}" target="_blank" class="flex items-center gap-3 p-3 bg-slate-50 hover:bg-indigo-50 border border-slate-100 hover:border-indigo-100 rounded-xl text-slate-700 hover:text-indigo-700 transition duration-200 group">
                    <span class="text-lg">📄</span>
                    <span class="text-xs font-bold truncate flex-1 text-left">${fileName}</span>
                    <span class="text-[10px] text-slate-400 group-hover:text-indigo-600 font-black">다운로드 ➔</span>
                </a>
            `;
        }
    }
    if (!filesHtml) {
        filesHtml = `
            <div class="col-span-full py-4 text-center bg-slate-50/50 rounded-xl border border-dashed border-slate-200 text-slate-400 text-xs">
                등록된 첨부 문서가 없습니다.
            </div>
        `;
    }

    let detailHtml = `
        <div class="space-y-6 max-h-[70vh] overflow-y-auto pr-2 custom-scrollbar">
            <!-- Title banner -->
            <div class="bg-indigo-50/40 p-6 rounded-[24px] border border-indigo-100/50">
                <p class="text-[10px] font-black text-indigo-500 uppercase tracking-wider mb-2">공고명</p>
                <p class="text-lg font-black text-slate-900 leading-snug">${ann.title}</p>
            </div>

            <!-- Detailed Grid columns -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Panel 1: Key Metadata -->
                <div class="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm space-y-3">
                    <h5 class="text-xs font-black text-slate-500 uppercase tracking-widest border-b pb-2 mb-2 flex items-center gap-2"><span>📌</span> 기본 정보</h5>
                    <div class="flex justify-between text-xs font-bold">
                        <span class="text-slate-400">공고번호</span>
                        <span class="text-slate-800">${bidNo}</span>
                    </div>
                    <div class="flex justify-between text-xs font-bold">
                        <span class="text-slate-400">수요기관</span>
                        <span class="text-slate-800">${demandOrg}</span>
                    </div>
                    <div class="flex justify-between text-xs font-bold">
                        <span class="text-slate-400">배정예산 (추정가격)</span>
                        <span class="text-indigo-600 font-extrabold">₩ ${formattedBudget}</span>
                    </div>
                    <div class="flex justify-between text-xs font-bold">
                        <span class="text-slate-400">공고일자</span>
                        <span class="text-slate-800">${regDate}</span>
                    </div>
                    <div class="flex justify-between text-xs font-bold">
                        <span class="text-slate-400">업종제한여부</span>
                        <span class="text-slate-800 font-black">${limitInfo}</span>
                    </div>
                </div>

                <!-- Panel 2: Scheduler & Dates -->
                <div class="bg-white p-5 rounded-2xl border border-slate-100 shadow-sm space-y-3">
                    <h5 class="text-xs font-black text-slate-500 uppercase tracking-widest border-b pb-2 mb-2 flex items-center gap-2"><span>📅</span> 입찰 및 제안 일정</h5>
                    <div class="flex flex-col text-xs font-bold space-y-1">
                        <span class="text-slate-400">1. 참가자격등록 기간</span>
                        <span class="text-slate-800 pl-3">${partcptTrm}</span>
                    </div>
                    <div class="flex flex-col text-xs font-bold space-y-1">
                        <span class="text-slate-400">2. 제안서 제출 기간</span>
                        <span class="text-slate-800 pl-3">${docTrm}</span>
                    </div>
                    <div class="flex flex-col text-xs font-bold space-y-1">
                        <span class="text-slate-400">3. 입찰 투찰 기간</span>
                        <span class="text-slate-800 pl-3">${bidTrm}</span>
                    </div>
                    <div class="flex justify-between text-xs font-bold pt-1">
                        <span class="text-slate-400">제안서 평가일</span>
                        <span class="text-slate-800">${evalTrm}</span>
                    </div>
                    <div class="flex justify-between text-xs font-bold">
                        <span class="text-slate-400">개찰일시</span>
                        <span class="text-rose-600 font-extrabold">${openTrm}</span>
                    </div>
                </div>
            </div>

            <!-- Panel 3: Contacts & Briefing -->
            <div class="bg-slate-50/50 p-5 rounded-2xl border border-slate-100 space-y-3">
                <h5 class="text-xs font-black text-slate-500 uppercase tracking-widest border-b pb-2 mb-2 flex items-center gap-2"><span>👤</span> 담당자 및 설명회 정보</h5>
                <div class="flex justify-between text-xs font-bold">
                    <span class="text-slate-400">공고 담당자</span>
                    <span class="text-slate-800">${managerInfo}</span>
                </div>
                <div class="flex justify-between text-xs font-bold">
                    <span class="text-slate-400">담당 이메일</span>
                    <span class="text-slate-800">${ann.managerEmail || '--'}</span>
                </div>
                <div class="flex flex-col text-xs font-bold space-y-1">
                    <span class="text-slate-400">현장 설명회</span>
                    <span class="text-slate-800">${dcmtgInfo}</span>
                </div>
            </div>

            <!-- Documents section -->
            <div>
                <h5 class="text-xs font-black text-slate-500 uppercase tracking-widest mb-3 px-1">📎 첨부 입찰 규격서 / 공고 문서</h5>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    ${filesHtml}
                </div>
            </div>

            <!-- Link out -->
            <div class="pt-2">
                <a href="${finalUrl}" target="_blank" class="w-full bg-slate-950 text-white font-bold py-3.5 rounded-xl hover:bg-slate-900 transition flex items-center justify-center gap-2 text-xs shadow-md">
                    <span>나라장터 상세 공고 페이지 바로가기 ➔</span>
                </a>
            </div>
        </div>
    `;

    const modal = document.createElement('div');
    modal.className = "fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-[300] flex items-center justify-center p-4 fade-in";
    modal.innerHTML = `
        <div class="bg-white rounded-[32px] shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col scale-in border border-white/20">
            <div class="px-8 py-6 border-b border-gray-100 flex justify-between items-center bg-white">
                <h4 class="text-xl font-black text-slate-900 tracking-tight">공고 상세 정보</h4>
                <button onclick="this.closest('.fixed').remove()" class="text-3xl text-slate-300 hover:text-rose-500 transition-colors">&times;</button>
            </div>
            <div class="p-8">
                ${detailHtml}
            </div>
            <div class="px-8 py-5 bg-slate-50 border-t border-gray-100 flex justify-end gap-3">
                <button onclick="this.closest('.fixed').remove()" class="px-8 py-2.5 bg-slate-800 text-white font-bold rounded-2xl shadow-lg hover:bg-slate-900 transition-all">닫기</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
}

async function loadSourcingHistory(page = 1) {
    const tbody = document.getElementById('sourcing-history-body');
    const paginationContainer = document.getElementById('sourcing-pagination');
    if (!tbody) return;

    try {
        const { sourcingService } = await import('../services/sourcingService.js');
        let history = [];
        try {
            const res = await sourcingService.getSavedAnnouncements();
            history = Array.isArray(res) ? res : [];
        } catch (dbErr) {
            console.error("[loadSourcingHistory] DB fetch failed, falling back to local storage:", dbErr);
            const localRaw = localStorage.getItem('auraDoc_localAnnouncements');
            try {
                const parsed = JSON.parse(localRaw || '[]');
                history = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
                history = [];
            }
        }
        
        sourcingPagination.totalRecords = history.length;
        sourcingPagination.currentPage = page;
        
        if (history.length === 0) {
            tbody.innerHTML = '<tr><td colspan="7" class="py-20 text-center text-slate-400 font-medium italic">수집된 내역이 없습니다. (DB가 비어있습니다)</td></tr>';
            if (paginationContainer) paginationContainer.innerHTML = '';
            return;
        }

        // Sort by date descending
        history.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));

        const start = (page - 1) * sourcingPagination.pageSize;
        const end = start + sourcingPagination.pageSize;
        const pagedHistory = history.slice(start, end);

        tbody.innerHTML = pagedHistory.map(ann => `
            <tr class="hover:bg-slate-50 transition-colors group">
                <td><span class="px-2 py-1 bg-emerald-50 text-emerald-600 text-[10px] font-black rounded-md border border-emerald-100">${ann.status === 'imported' ? '임포트' : '수집됨'}</span></td>
                <td class="text-xs font-bold text-indigo-500 cursor-pointer hover:underline" onclick="window.showSourcingDetail('${ann.id}')">${ann.id}</td>
                <td class="font-bold text-slate-800 line-clamp-1 max-w-[400px]">${ann.title}</td>
                <td class="text-sm text-slate-500">${ann.org}</td>
                <td class="font-black text-indigo-600 text-right">₩ ${new Intl.NumberFormat('ko-KR').format(ann.budget || 0)}</td>
                <td class="text-xs text-slate-400">${ann.deadline || '-'}</td>
                <td class="text-center flex items-center justify-center gap-2 py-4">
                    <button class="w-8 h-8 flex items-center justify-center bg-indigo-50 text-indigo-600 rounded-lg hover:bg-indigo-600 hover:text-white transition-all shadow-sm" onclick="window.startProposalFromAdminByID('${ann.id}')" title="제안 분석 시작">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                    </button>
                    <button class="w-8 h-8 flex items-center justify-center bg-slate-50 text-slate-500 rounded-lg hover:bg-amber-500 hover:text-white transition-all shadow-sm" onclick="window.editSourcingRecord('${ann.id}')" title="수정">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
                    </button>
                    <button class="w-8 h-8 flex items-center justify-center bg-slate-50 text-slate-500 rounded-lg hover:bg-rose-500 hover:text-white transition-all shadow-sm" onclick="window.deleteSourcingRecord('${ann.id}')" title="삭제">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                    </button>
                </td>
            </tr>
        `).join('');

        renderPagination();
    } catch (err) {
        console.error("[loadSourcingHistory] Main process error:", err);
        tbody.innerHTML = `<tr><td colspan="7" class="py-20 text-center text-rose-500 font-bold">공고 내역 로드 중 오류가 발생했습니다: ${err.message}</td></tr>`;
    }
}

function renderPagination() {
    const container = document.getElementById('sourcing-pagination');
    if (!container) return;

    const totalPages = Math.ceil(sourcingPagination.totalRecords / sourcingPagination.pageSize);
    const current = sourcingPagination.currentPage;

    let html = `
        <button onclick="window.loadSourcingHistory(${Math.max(1, current - 1)})" ${current === 1 ? 'disabled' : ''} class="px-4 py-2 rounded-xl border border-slate-200 bg-white text-slate-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-slate-50 transition-all font-bold">이전</button>
        <div class="flex gap-2">
    `;

    // Show limited range of pages
    const range = 2;
    for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= current - range && i <= current + range)) {
            html += `<button onclick="window.loadSourcingHistory(${i})" class="w-10 h-10 rounded-xl font-bold transition-all ${i === current ? 'bg-indigo-600 text-white shadow-lg' : 'bg-white text-slate-500 border border-slate-200 hover:bg-slate-50'}">${i}</button>`;
        } else if (i === current - range - 1 || i === current + range + 1) {
            html += `<span class="flex items-end pb-2 px-1 text-slate-400">...</span>`;
        }
    }

    html += `
        </div>
        <button onclick="window.loadSourcingHistory(${Math.min(totalPages, current + 1)})" ${current === totalPages ? 'disabled' : ''} class="px-4 py-2 rounded-xl border border-slate-200 bg-white text-slate-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-slate-50 transition-all font-bold">다음</button>
        <span class="ml-4 text-sm text-slate-400">총 ${sourcingPagination.totalRecords}개</span>
    `;

    container.innerHTML = html;
}

async function deleteSourcingRecord(id) {
    if (!confirm('정말로 이 공고를 삭제하시겠습니까?')) return;
    const { sourcingService } = await import('../services/sourcingService.js');
    const success = await sourcingService.deleteAnnouncement(id);
    if (success) {
        alert('삭제되었습니다.');
        loadSourcingHistory(sourcingPagination.currentPage);
    }
}

async function editSourcingRecord(id) {
    const { sourcingService } = await import('../services/sourcingService.js');
    const history = await sourcingService.getSavedAnnouncements();
    const ann = history.find(a => a.id === id);
    if (!ann) return;

    // Show edit modal (reusing logic but adding inputs)
    const modal = document.createElement('div');
    modal.className = "fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-[300] flex items-center justify-center p-4 fade-in";
    modal.innerHTML = `
        <div class="bg-white rounded-[32px] shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col scale-in border border-white/20">
            <div class="px-8 py-6 border-b border-gray-100 flex justify-between items-center bg-white">
                <h4 class="text-xl font-black text-slate-900 tracking-tight">공고 정보 수정</h4>
                <button onclick="this.closest('.fixed').remove()" class="text-3xl text-slate-300 hover:text-rose-500 transition-colors">&times;</button>
            </div>
            <div class="p-8 space-y-6">
                <div>
                    <label class="block text-[11px] font-black text-slate-400 mb-2 uppercase">공고명</p>
                    <input type="text" id="edit-ann-title" class="form-input" value="${ann.title}">
                </div>
                <div class="grid grid-cols-2 gap-6">
                    <div>
                        <label class="block text-[11px] font-black text-slate-400 mb-2 uppercase">기관명</p>
                        <input type="text" id="edit-ann-org" class="form-input" value="${ann.org}">
                    </div>
                    <div>
                        <label class="block text-[11px] font-black text-slate-400 mb-2 uppercase">추정가격 (숫자만)</p>
                        <input type="number" id="edit-ann-budget" class="form-input" value="${ann.budget}">
                    </div>
                </div>
                <div>
                    <label class="block text-[11px] font-black text-slate-400 mb-2 uppercase">마감일시</p>
                    <input type="text" id="edit-ann-deadline" class="form-input" value="${ann.deadline}">
                </div>
            </div>
            <div class="px-8 py-5 bg-slate-50 border-t border-gray-100 flex justify-end gap-3">
                <button onclick="this.closest('.fixed').remove()" class="px-6 py-2.5 bg-white border border-slate-200 text-slate-500 font-bold rounded-2xl">취소</button>
                <button id="btn-save-edit-ann" class="px-8 py-2.5 bg-indigo-600 text-white font-bold rounded-2xl shadow-lg hover:bg-indigo-700 transition-all">저장하기</button>
            </div>
        </div>
    `;
    document.body.appendChild(modal);

    document.getElementById('btn-save-edit-ann').onclick = async () => {
        const updated = {
            ...ann,
            title: document.getElementById('edit-ann-title').value,
            org: document.getElementById('edit-ann-org').value,
            budget: Number(document.getElementById('edit-ann-budget').value),
            deadline: document.getElementById('edit-ann-deadline').value
        };
        const success = await sourcingService.saveAnnouncements([updated]);
        if (success) {
            alert('저장되었습니다.');
            modal.remove();
            loadSourcingHistory(sourcingPagination.currentPage);
        }
    };
}

async function adminClearSourcingHistory() {
    if (!confirm("정말로 수집된 모든 공고 내역을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.")) return;
    const { sourcingService } = await import('../services/sourcingService.js');
    const success = await sourcingService.clearSavedAnnouncements();
    if (success) {
        alert("모든 수집 내역이 소거되었습니다.");
        loadSourcingHistory(1);
    } else {
        alert("내역 소거 중 오류가 발생했습니다.");
    }
}

window.startProposalFromAdmin = startProposalFromAdmin;
window.syncInitialSourcingData = syncInitialSourcingData;
window.loadSourcingHistory = loadSourcingHistory; 

async function adminExportExcel() {
    const { sourcingService } = await import('../services/sourcingService.js');
    const announcements = await sourcingService.getSavedAnnouncements();
    if (announcements.length === 0) {
        alert("내보낼 공고 수집 내역이 없습니다.");
        return;
    }
    
    // Build CSV content with BOM for Korean character Excel compatibility
    let csvContent = "\uFEFF";
    csvContent += "공고구분,공고번호,입찰공고명,수요기관,배정예산(원),공고일자,마감일시,낙찰자결정방법,참가제한업종\n";
    
    announcements.forEach(item => {
        const clean = (val) => {
            if (!val) return "";
            return '"' + String(val).replace(/"/g, '""').replace(/\r?\n/g, ' ') + '"';
        };
        const status = item.raw?.bidNtceSttusNm || "일반공고";
        const decision = item.raw?.bidwinrDcsnMthdNm || "협상에 의한 계약";
        const industry = item.raw?.bidprcPsblIndstrytyNm || "제한없음";
        csvContent += `${clean(status)},${clean(item.id)},${clean(item.title)},${clean(item.org)},${item.budget},${clean(item.date)},${clean(item.deadline)},${clean(decision)},${clean(industry)}\n`;
    });
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `AuraDoc_Sourcing_Export_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

window.adminExportExcel = adminExportExcel; 
window.triggerManualFetch = triggerManualFetch; 
window.showSourcingDetail = showSourcingDetail; 
window.deleteSourcingRecord = deleteSourcingRecord;
window.editSourcingRecord = editSourcingRecord;
window.adminClearSourcingHistory = adminClearSourcingHistory;

let agentMonitorInterval = null;
let agentUptimeTimer = null;

async function loadSourcingAgentDashboard() {
    try {
        if (agentMonitorInterval) clearInterval(agentMonitorInterval);
        if (agentUptimeTimer) clearInterval(agentUptimeTimer);

        let sourcingService;
        try {
            const module = await import('../services/sourcingService.js');
            sourcingService = module.sourcingService;
        } catch (e) {
            console.error("[loadSourcingAgentDashboard] Failed to import sourcingService:", e);
            const consoleLogs = document.getElementById('agent-logs-console');
            if (consoleLogs) consoleLogs.innerText = "소싱 모듈을 임포트하지 못했습니다: " + e.message;
            return;
        }

        let currentUptime = 0;
        let lastAgentStatus = '';
        const startUptimeTicker = (status, initialUptime) => {
            const targetUptime = initialUptime || 0;
            const drift = Math.abs(currentUptime - targetUptime);

            if (lastAgentStatus !== status || drift > 3) {
                lastAgentStatus = status;
                currentUptime = targetUptime;

                if (agentUptimeTimer) clearInterval(agentUptimeTimer);
                
                const uptimeDisplay = document.getElementById('agent-uptime-display');
                if (!uptimeDisplay) return;

                if (status !== 'running') {
                    uptimeDisplay.innerText = "0초";
                    return;
                }

                uptimeDisplay.innerText = `${currentUptime}초`;
                agentUptimeTimer = setInterval(() => {
                    const viewContainer = document.getElementById('view-sourcingAgent');
                    if (!viewContainer || viewContainer.classList.contains('hidden-view')) {
                        clearInterval(agentUptimeTimer);
                        return;
                    }
                    currentUptime++;
                    uptimeDisplay.innerText = `${currentUptime}초`;
                }, 1000);
            }
        };

        const refreshDashboard = async () => {
            try {
                const data = await sourcingService.getAgentStatus();
                updateUI(data);
            } catch (e) {
                console.error("[loadSourcingAgentDashboard] Failed to refresh agent dashboard:", e);
                updateUI(null);
            }
        };

        const bindButtons = (effectiveStatus, isTimerIdle = false) => {
            const startBtn = document.getElementById('btn-agent-start');
            const restartBtn = document.getElementById('btn-agent-restart');
            const stopBtn = document.getElementById('btn-agent-stop');
            const enableManualRun = (btn, label, title) => {
                if (!btn) return;
                btn.disabled = false;
                btn.setAttribute('aria-disabled', 'false');
                btn.classList.remove('opacity-50', 'cursor-not-allowed');
                btn.title = title;
                btn.onclick = async () => {
                    btn.disabled = true;
                    btn.classList.add('opacity-50', 'cursor-not-allowed');
                    const originalText = btn.innerHTML;
                    btn.innerHTML = '<span>실행 중...</span>';
                    try {
                        await triggerManualFetch();
                        await refreshDashboard();
                    } finally {
                        btn.innerHTML = originalText || label;
                        btn.disabled = false;
                        btn.classList.remove('opacity-50', 'cursor-not-allowed');
                    }
                };
            };

            [startBtn, restartBtn, stopBtn].forEach(btn => {
                if (btn) {
                    btn.disabled = true;
                    btn.setAttribute('aria-disabled', 'true');
                    btn.classList.add('opacity-50', 'cursor-not-allowed');
                    btn.onclick = null;
                    if (effectiveStatus === 'disconnected') {
                        btn.title = "연결 실패: 8787 포트 데몬 및 heartbeat 수신 상태를 점검하십시오.";
                    } else {
                        btn.title = "서비스 미구성: OCI VM 제어를 위한 서버 측 Control API가 제공되지 않습니다.";
                    }
                }
            });

            if (isTimerIdle) {
                if (startBtn) startBtn.innerText = '▶ 수동 동기화';
                if (restartBtn) restartBtn.innerText = '🔄 다시 동기화';
                enableManualRun(startBtn, '▶ 수동 동기화', '브라우저에서 조달청 OpenAPI 수동 동기화를 한 번 실행합니다.');
                enableManualRun(restartBtn, '🔄 다시 동기화', '최근 수집 완료 후 조달청 OpenAPI 수동 동기화를 다시 실행합니다.');
                if (stopBtn) stopBtn.title = '대기 중에는 종료할 상주 프로세스가 없습니다.';
            }
        };

        const updateUI = (rawData) => {
            const overallStatus = document.getElementById('agent-overall-status');
            const cpuDisplay = document.getElementById('agent-cpu-display');
            const cpuBar = document.getElementById('agent-cpu-bar');
            const memDisplay = document.getElementById('agent-mem-display');
            const memBar = document.getElementById('agent-mem-bar');
            const pidDisplay = document.getElementById('agent-pid-display');
            const consoleLogs = document.getElementById('agent-logs-console');
            const warningEl = document.getElementById('agent-control-warning-text');

            if (!overallStatus) return;

            const data = rawData || { 
                status: 'unknown', 
                cpu_percent: null, 
                memory_percent: null, 
                pid: null, 
                uptime_seconds: 0,
                last_seen_at: null,
                metadata: { log_tail: ["📡 OCI VM Sourcing Daemon is offline or unreachable."] } 
            };

            // Calculate freshness (heartbeat elapsed)
            let elapsed = null;
            let freshnessText = "연결 끊김";
            if (data.last_seen_at) {
                elapsed = Math.floor((new Date() - new Date(data.last_seen_at)) / 1000);
                if (elapsed >= 0) {
                    if (elapsed < 60) {
                        freshnessText = `${elapsed}초 전`;
                    } else {
                        const mins = Math.floor(elapsed / 60);
                        freshnessText = `${mins}분 전`;
                    }
                }
            }

            // Treat as disconnected if heartbeat is older than 60 seconds
            let effectiveStatus = data.status;
            if (!data.last_seen_at || (elapsed !== null && elapsed > 60)) {
                effectiveStatus = 'disconnected';
            }
            const logTail = Array.isArray(data.metadata?.log_tail) ? data.metadata.log_tail : [];
            const lastRunSucceeded = logTail.some(line => /completed successfully|Upload success|Deactivated successfully/i.test(String(line)));
            const isTimerIdle = effectiveStatus === 'stopped' && elapsed !== null && elapsed <= 60 && lastRunSucceeded;

            if (effectiveStatus === 'running') {
                overallStatus.innerText = "🟢 실행 중";
                overallStatus.className = "px-4 py-2 rounded-full font-black text-xs shadow bg-emerald-100 text-emerald-700 animate-pulse";
            } else if (effectiveStatus === 'error') {
                overallStatus.innerText = "🔴 데몬 오류";
                overallStatus.className = "px-4 py-2 rounded-full font-black text-xs shadow bg-rose-100 text-rose-700";
            } else if (isTimerIdle) {
                overallStatus.innerText = "🟡 대기 중";
                overallStatus.className = "px-4 py-2 rounded-full font-black text-xs shadow bg-amber-100 text-amber-700";
            } else if (effectiveStatus === 'stopped') {
                overallStatus.innerText = "🟡 중지됨";
                overallStatus.className = "px-4 py-2 rounded-full font-black text-xs shadow bg-amber-100 text-amber-700";
            } else if (effectiveStatus === 'disconnected') {
                overallStatus.innerText = "🔌 연결 끊김";
                overallStatus.className = "px-4 py-2 rounded-full font-black text-xs shadow bg-slate-100 text-slate-500";
            } else {
                overallStatus.innerText = "❓ 알 수 없음";
                overallStatus.className = "px-4 py-2 rounded-full font-black text-xs shadow bg-slate-100 text-slate-500";
            }

            // Bind warnings based on status
            if (warningEl) {
                if (effectiveStatus === 'disconnected') {
                    warningEl.innerText = "⚠️ 연결 실패 (heartbeat 만료): 최근 60초간 데몬 생존 신호가 수신되지 않았습니다. VM의 auradoc-heartbeat-reporter 서비스와 AURADOC_AGENT_TOKEN 설정을 확인해야 합니다.";
                } else if (isTimerIdle) {
                    warningEl.innerText = "✅ 최근 수집 작업이 성공적으로 완료되었습니다. 타이머 기반 수집기는 실행할 작업이 없을 때 대기 상태로 표시됩니다.";
                } else if (effectiveStatus === 'stopped') {
                    warningEl.innerText = "⚠️ 서비스 중지: 수집기 데몬 프로세스가 명시적으로 중지된 상태입니다.";
                } else {
                    warningEl.innerText = "⚠️ 서비스 미구성: OCI VM 제어를 위한 서버 측 Control API가 현재 구성되지 않았습니다.";
                }
            }

            const isOnline = effectiveStatus === 'running';
            const cpuVal = (isOnline && typeof data.cpu_percent === 'number') ? data.cpu_percent : null;
            const memVal = (isOnline && typeof data.memory_percent === 'number') ? data.memory_percent : null;
            
            if (cpuDisplay) cpuDisplay.innerText = cpuVal !== null ? cpuVal.toFixed(1) : '--';
            if (cpuBar) cpuBar.style.width = cpuVal !== null ? `${Math.min(100, Math.max(0, cpuVal))}%` : '0%';
            if (memDisplay) memDisplay.innerText = memVal !== null ? memVal.toFixed(1) : '--';
            if (memBar) memBar.style.width = memVal !== null ? `${Math.min(100, Math.max(0, memVal))}%` : '0%';

            const currentPid = (isOnline && data.pid) ? data.pid : '--';
            if (pidDisplay) {
                pidDisplay.innerText = `PID: ${currentPid} (Port: 8787) | 최근 활성: ${freshnessText}`;
            }

            startUptimeTicker(effectiveStatus, data.uptime_seconds);
            bindButtons(effectiveStatus, isTimerIdle);

            if (consoleLogs) {
                const logLines = logTail;
                if (logLines.length > 0) {
                    const diagnosticLines = effectiveStatus === 'disconnected'
                        ? [
                            '진단 필요: heartbeat-reporter가 Cloudflare /api/collector/agent-heartbeat 로 상태를 보내지 못하고 있습니다.',
                            '확인 명령: systemctl status auradoc-heartbeat-reporter',
                            '확인 명령: journalctl -u auradoc-heartbeat-reporter -n 80 --no-pager',
                            '확인 항목: AURADOC_AGENT_TOKEN, API_BASE_URL, VM 네트워크, systemd 서비스 활성 상태',
                            ''
                        ]
                        : [];
                    consoleLogs.innerText = [...diagnosticLines, ...logLines].join('\n');
                } else {
                    consoleLogs.innerText = "로그가 존재하지 않습니다.";
                }
            }
        };

        await refreshDashboard();

        agentMonitorInterval = setInterval(async () => {
            const viewContainer = document.getElementById('view-sourcingAgent');
            if (!viewContainer || viewContainer.classList.contains('hidden-view')) {
                clearInterval(agentMonitorInterval);
                if (agentUptimeTimer) clearInterval(agentUptimeTimer);
                return;
            }
            await refreshDashboard();
        }, 3000);
    } catch (err) {
        console.error("[loadSourcingAgentDashboard] Critical Error:", err);
        const consoleLogs = document.getElementById('agent-logs-console');
        if (consoleLogs) {
            consoleLogs.innerText = "대시보드 로드 중 치명적 예외가 발생했습니다: " + err.message;
        }
    }
}

window.loadSourcingAgentDashboard = loadSourcingAgentDashboard;

window.loadPersonalNaverConfig = async function() {
    try {
        const config = await naverBlogService.getConfig();
        if (config) {
            const naverIdEl = document.getElementById('personal-naver-id');
            const clientIdEl = document.getElementById('personal-naver-client-id');
            const clientSecretEl = document.getElementById('personal-naver-client-secret');
            
            if (naverIdEl) naverIdEl.value = config.naverId || '';
            if (clientIdEl) clientIdEl.value = config.clientId || '';
            if (clientSecretEl) clientSecretEl.value = config.clientSecret || '';
        }
    } catch (e) {
        console.error("Failed to load personal naver config", e);
    }
};

window.savePersonalNaverConfig = async function() {
    try {
        const naverId = document.getElementById('personal-naver-id')?.value || '';
        const clientId = document.getElementById('personal-naver-client-id')?.value || '';
        const clientSecret = document.getElementById('personal-naver-client-secret')?.value || '';

        const config = { naverId, clientId, clientSecret };
        await naverBlogService.saveConfig(config);
        alert("네이버 블로그 연동 설정이 성공적으로 저장되었습니다.");
    } catch (e) {
        console.error("Failed to save personal naver config", e);
        alert("연동 설정 저장 실패: " + e.message);
    }
};

window.testPersonalNaverConfig = async function() {
    const naverId = document.getElementById('personal-naver-id')?.value || '';
    const clientId = document.getElementById('personal-naver-client-id')?.value || '';
    const clientSecret = document.getElementById('personal-naver-client-secret')?.value || '';

    if (!naverId || !clientId || !clientSecret) {
        alert("모든 네이버 연동 설정을 입력한 후 테스트를 시도하세요.");
        return;
    }
    
    alert("입력하신 네이버 연동 정보 형식이 유효합니다. (테스트 성공)");
};
